window.theme = window.theme || {};

window.Slate = window.Slate || {};

(function() {
  var swatchDebugVersion = 'theme-js-liquid-admin-swatch-diagnostics';

  function isSwatchDebugEnabled() {
    return (
      window.location.search
        .replace(/^\?/, '')
        .split('&')
        .indexOf('swatch_debug=1') !== -1
    );
  }

  function escapeHtml(value) {
    return (value || '')
      .toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getProductSwatchesDebugData() {
    var scripts = Array.prototype.slice.call(
      document.querySelectorAll('[id^="ProductSwatches-"]')
    );

    return scripts.map(function(script) {
      var raw = script.textContent || '';
      var entry = {
        id: script.id,
        rawLength: raw.length,
        rawPreview: raw.length > 1000 ? raw.slice(0, 1000) + '...' : raw,
        jsonError: '',
        optionsLength: 0,
        optionsWithImage: 0,
        optionsWithColor: 0,
        optionNames: [],
        valueNames: []
      };

      try {
        var parsed = JSON.parse(raw || '{}');
        var options = parsed.options || [];

        entry.optionsLength = options.length;
        entry.optionsWithImage = options.filter(function(option) {
          return !!option.image;
        }).length;
        entry.optionsWithColor = options.filter(function(option) {
          return !!option.color;
        }).length;
        entry.optionNames = options.map(function(option) {
          return option.optionName || '';
        });
        entry.valueNames = options.map(function(option) {
          return option.valueName || '';
        });
      } catch (err) {
        entry.jsonError = err.message;
      }

      return entry;
    });
  }

  function renderEarlySwatchDebugPanel() {
    if (!isSwatchDebugEnabled() || !document.body) return;

    var panel = document.getElementById('SwatchDebugEarlyPanel');

    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'SwatchDebugEarlyPanel';
      panel.style.position = 'fixed';
      panel.style.left = '12px';
      panel.style.bottom = '12px';
      panel.style.zIndex = '2147483647';
      panel.style.maxWidth = '520px';
      panel.style.maxHeight = '50vh';
      panel.style.overflow = 'auto';
      panel.style.padding = '12px';
      panel.style.background = '#ffffff';
      panel.style.border = '1px solid #111111';
      panel.style.boxShadow = '0 2px 12px rgba(0, 0, 0, 0.2)';
      panel.style.color = '#111111';
      panel.style.fontFamily = 'monospace';
      panel.style.fontSize = '12px';
      panel.style.lineHeight = '1.4';
      panel.style.textAlign = 'left';
      document.body.appendChild(panel);
    }

    panel.innerHTML =
      '<strong>Early swatch diagnostics</strong>' +
      '<pre style="white-space: pre-wrap; margin: 8px 0 0;">' +
      escapeHtml(
        JSON.stringify(
          {
            themeJsSwatchDebugVersion: swatchDebugVersion,
            productJsonIds: Array.prototype.slice
              .call(document.querySelectorAll('[id^="ProductJson-"]'))
              .map(function(script) {
                return script.id;
              }),
            productSwatchesFound: getProductSwatchesDebugData()
          },
          null,
          2
        )
      ) +
      '</pre>';
  }

  if (isSwatchDebugEnabled()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', renderEarlySwatchDebugPanel);
    } else {
      renderEarlySwatchDebugPanel();
    }

    window.addEventListener('load', renderEarlySwatchDebugPanel);
  }

  theme.renderEarlySwatchDebugPanel = renderEarlySwatchDebugPanel;
})();

/**
 *
 *  Slate a11y-helpers
 *
 */
Slate.A11yHelpers = (function() {
  var A11yHelpers = function() {
    this.init();

    $('.in-page-link').on(
      'click',
      $.proxy(function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }, this)
    );
  };

  A11yHelpers.prototype.init = function() {
    // on init, check if we need to set page focus
    var hash = window.location.hash;
    if (hash) {
      if (document.getElementById(hash.slice(1))) {
        this.pageLinkFocus($(hash));
      }
    }
  };

  A11yHelpers.prototype.trapFocus = function($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');
    $(document).on(eventName, function(evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  A11yHelpers.prototype.removeTrapFocus = function($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  /*
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area
   * so that next `tab` is where user expects
   * if focusing a link, just $link.focus();
  */
  A11yHelpers.prototype.pageLinkFocus = function($element) {
    if (!$element.length) return;

    $element.get(0).tabIndex = -1;
    $element.focus().addClass('js-focus-hidden');
    $element.one('blur', function() {
      $element.removeClass('js-focus-hidden').removeAttr('tabindex');
    });
  };

  return A11yHelpers;
})();

/**
 *
 *  Slate uri-helpers
 *
 */

// Based off the node module query-string https://github.com/sindresorhus/query-string
('use strict');
Slate.QueryString = (function() {
  var _encode = function(value) {
    return encodeURIComponent(value);
  };

  return {
    parse: function(str) {
      var ret = Object.create(null);

      if (typeof str !== 'string') {
        return ret;
      }

      str = str.trim().replace(/^(\?|#|&)/, '');

      if (!str) {
        return ret;
      }

      str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;

        key = decodeURIComponent(key);

        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : decodeURIComponent(val);

        if (ret[key] === undefined) {
          ret[key] = val;
        } else if (Array.isArray(ret[key])) {
          ret[key].push(val);
        } else {
          ret[key] = [ret[key], val];
        }
      });

      return ret;
    },

    stringify: function(obj) {
      return obj
        ? Object.keys(obj)
            .sort()
            .map(function(key) {
              var val = obj[key];

              if (val === undefined) {
                return '';
              }

              if (val === null) {
                return key;
              }

              if (Array.isArray(val)) {
                var result = [];

                val
                  .slice()
                  .sort()
                  .forEach(function(val2) {
                    if (val2 === undefined) return;

                    if (val2 === null) {
                      result.push(_encode(key));
                    } else {
                      result.push(_encode(key) + '=' + _encode(val2));
                    }
                  });

                return result.join('&');
              }

              return _encode(key) + '=' + _encode(val);
            })
            .filter(function(x) {
              return x.length > 0;
            })
            .join('&')
        : '';
    }
  };
})();

/**
 *
 *  Initialize function for all Slate JS.
 *  - call any functions required on page load here.
 *
 */
Slate.init = function() {
  new Slate.A11yHelpers();
  Slate.checkUrlHash();
  Slate.initEventListeners();
  Slate.resetPasswordSuccess();
  Slate.customerAddressForm();
  Slate.rteElements();
  Slate.giftCardTemplate();
};

Slate.initEventListeners = function() {
  // Show reset password form
  $('#RecoverPassword').on('click', function(evt) {
    evt.preventDefault();
    Slate.toggleRecoverPasswordForm();
  });

  // Hide reset password form
  $('#HideRecoverPasswordLink').on('click', function(evt) {
    evt.preventDefault();
    Slate.toggleRecoverPasswordForm();
  });
};

/**
 *
 *  Show/Hide recover password form
 *
 */
Slate.toggleRecoverPasswordForm = function() {
  $('#RecoverPasswordForm').toggleClass('hide');
  $('#CustomerLoginForm').toggleClass('hide');
};

/**
 *
 *  Show reset password success message
 *
 */
Slate.resetPasswordSuccess = function() {
  var $formState = $('.reset-password-success');

  // check if reset password form was successfully submited.
  if (!$formState.length) return;

  // show success message
  $('#ResetSuccess').removeClass('hide');
};

/**
 *
 *  Show/hide customer address forms
 *
 */
Slate.customerAddressForm = function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) return;

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      'AddressCountryNew',
      'AddressProvinceNew',
      {
        hideElement: 'AddressProvinceContainerNew'
      }
    );
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var addressUrl = $el.data('address-url');
    var confirmMessage = $el.data('confirm-message');
    if (
      confirm(confirmMessage || 'Are you sure you wish to delete this address?')
    ) {
      Shopify.postLink(addressUrl, {
        parameters: { _method: 'delete' }
      });
    }
  });
};

/**
 *
 *  Wrap tables in the RTE with a scrollable div
 *  so they cannot break the layout if too wide.
 *  Wrap videos in div to force responsive layout.
 *
 */
Slate.rteElements = function() {
  $('.rte table').wrap('<div class="rte__table-wrapper"></div>');

  var $iframeVideo = $(
    'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'
  );
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function() {
    // Add wrapper to make video responsive
    if (!$(this).parents('.video-wrapper').length) {
      $(this).wrap('<div class="video-wrapper"></div>');
    }
  });

  $iframeReset.each(function() {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

/**
 *
 *  Adjust option_selection.js labels based on variant default values
 *
 */
Slate.simplifyVariantLabels = function(product, container) {
  // option_selection.js does not add a label if there is only one variant option.
  // Add one as long as it is not 'Title' (Shopify's default), add one.
  if (product.options.length === 1 && product.options[0] !== 'Title') {
    $('.selector-wrapper:eq(0)', container).prepend(
      '<label for="ProductSelect-option-0">' + product.options[0] + '</label>'
    );
  }
};

/**
 *
 *  Gift card template helpers
 *
 */
Slate.giftCardTemplate = function() {
  if (!$('body').hasClass('template-giftcard')) return;

  new QRCode(document.getElementById('QrCode'), {
    text: $('#QrCode').data('identifier'),
    width: 120,
    height: 120
  });

  $('#PrintGiftCard').on('click', function() {
    window.print();
  });

  /*=============================================================================
    Auto-select gift card code on click, based on ID passed to the function
  ==============================================================================*/
  $('.giftcard__code').on('click', { element: 'GiftCardDigits' }, selectText);

  function selectText(evt) {
    var doc = document,
      text = doc.getElementById(evt.data.element),
      range;

    if (doc.body.createTextRange) {
      // ms method
      range = doc.body.createTextRange();
      range.moveToElementText(text);
      range.select();
    } else if (window.getSelection) {
      // moz, opera, webkit method
      var selection = window.getSelection();

      range = doc.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
};

/**
 *
 *  Check URL for reset password hash
 *
 */
Slate.checkUrlHash = function() {
  var hash = window.location.hash;

  // Allow deep linking to recover password form
  if (hash === '#recover') {
    Slate.toggleRecoverPasswordForm();
  }
};

// Initialize Slate's JS on docready
$(Slate.init);

theme.strings = {
  addToCart: "カートに追加する",
  itemAddedToCart: "カートに追加しました",
  soldOut: "SOLD OUT",
  unavailable: "お取り扱いできません",
  viewCart: "カートを見る",
  zoomClose: "閉じる (Esc)",
  zoomPrev: "前へ (Left arrow key)",
  zoomNext: "次へ (Right arrow key)"
};

/*!
 * enquire.js v2.1.2 - Awesome Media Queries in JavaScript
 * Copyright (c) 2014 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
!function(a,b,c){var d=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=c(d):"function"==typeof define&&define.amd?define(function(){return b[a]=c(d)}):b[a]=c(d)}("enquire",this,function(a){"use strict";function b(a,b){var c,d=0,e=a.length;for(d;e>d&&(c=b(a[d],d),c!==!1);d++);}function c(a){return"[object Array]"===Object.prototype.toString.apply(a)}function d(a){return"function"==typeof a}function e(a){this.options=a,!a.deferSetup&&this.setup()}function f(b,c){this.query=b,this.isUnconditional=c,this.handlers=[],this.mql=a(b);var d=this;this.listener=function(a){d.mql=a,d.assess()},this.mql.addListener(this.listener)}function g(){if(!a)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!a("only all").matches}return e.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},f.prototype={addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var c=this.handlers;b(c,function(b,d){return b.equals(a)?(b.destroy(),!c.splice(d,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){b(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";b(this.handlers,function(b){b[a]()})}},g.prototype={register:function(a,e,g){var h=this.queries,i=g&&this.browserIsIncapable;return h[a]||(h[a]=new f(a,i)),d(e)&&(e={match:e}),c(e)||(e=[e]),b(e,function(b){d(b)&&(b={match:b}),h[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},new g});

/*! Magnific Popup - v1.0.0 - 2015-03-30
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2015 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isIE7=-1!==c.indexOf("MSIE 7."),b.isIE8=-1!==c.indexOf("MSIE 8."),b.isLowIE=b.isIE7||b.isIE8,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",b.ev=c.mainEl&&c.mainEl.length?c.mainEl.eq(0):d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.wrap.css(b.fixedContentPos?{overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}:{top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),b.currTemplate[d]=f?a(f):!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||2!==c.which&&!c.ctrlKey&&!c.metaKey){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(a,c){if(void 0===c||c===!1)return!0;if(e=a.split("_"),e.length>1){var d=b.find(p+"-"+e[0]);if(d.length>0){var f=e[1];"replaceWith"===f?d[0]!==c[0]&&d.replaceWith(c):"img"===f?d.is("img")?d.attr("src",c):d.replaceWith('<img src="'+c+'" class="'+d.attr("class")+'" />'):d.attr(e[1],c)}}else b.find(p+"-"+a).html(c)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&times;</button>',tClose:"Close (Esc)",tLoading:"Loading..."}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery",g=Boolean(a.fn.mfpFastClick);return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s),h=g?"mfpFastClick":"click";e[h](function(){b.prev()}),f[h](function(){b.next()}),b.isIE7&&(x("b",e[0],!1,!0),x("a",e[0],!1,!0),x("b",f[0],!1,!0),x("a",f[0],!1,!0)),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowLeft&&g&&b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),function(){var b=1e3,c="ontouchstart"in window,d=function(){v.off("touchmove"+f+" touchend"+f)},e="mfpFastClick",f="."+e;a.fn.mfpFastClick=function(e){return a(this).each(function(){var g,h=a(this);if(c){var i,j,k,l,m,n;h.on("touchstart"+f,function(a){l=!1,n=1,m=a.originalEvent?a.originalEvent.touches[0]:a.touches[0],j=m.clientX,k=m.clientY,v.on("touchmove"+f,function(a){m=a.originalEvent?a.originalEvent.touches:a.touches,n=m.length,m=m[0],(Math.abs(m.clientX-j)>10||Math.abs(m.clientY-k)>10)&&(l=!0,d())}).on("touchend"+f,function(a){d(),l||n>1||(g=!0,a.preventDefault(),clearTimeout(i),i=setTimeout(function(){g=!1},b),e())})})}h.on("click"+f,function(){g||e()})})},a.fn.destroyMfpFastClick=function(){a(this).off("touchstart"+f+" click"+f),c&&v.off("touchmove"+f+" touchend"+f)}}(),A()});

/*
 * jQuery FlexSlider v2.2.2
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */
!function(a){a.flexslider=function(b,c){var d=a(b);d.vars=a.extend({},a.flexslider.defaults,c);var j,e=d.vars.namespace,f=window.navigator&&window.navigator.msPointerEnabled&&window.MSGesture,g=("ontouchstart"in window||f||window.DocumentTouch&&document instanceof DocumentTouch)&&d.vars.touch,h="click touchend MSPointerUp",i="",k="vertical"===d.vars.direction,l=d.vars.reverse,m=d.vars.itemWidth>0,n="fade"===d.vars.animation,o=""!==d.vars.asNavFor,p={},q=!0;a.data(b,"flexslider",d),p={init:function(){d.animating=!1,d.currentSlide=parseInt(d.vars.startAt?d.vars.startAt:0,10),isNaN(d.currentSlide)&&(d.currentSlide=0),d.animatingTo=d.currentSlide,d.atEnd=0===d.currentSlide||d.currentSlide===d.last,d.containerSelector=d.vars.selector.substr(0,d.vars.selector.search(" ")),d.slides=a(d.vars.selector,d),d.container=a(d.containerSelector,d),d.count=d.slides.length,d.syncExists=a(d.vars.sync).length>0,"slide"===d.vars.animation&&(d.vars.animation="swing"),d.prop=k?"top":"marginLeft",d.args={},d.manualPause=!1,d.stopped=!1,d.started=!1,d.startTimeout=null,d.transitions=!d.vars.video&&!n&&d.vars.useCSS&&function(){var a=document.createElement("div"),b=["perspectiveProperty","WebkitPerspective","MozPerspective","OPerspective","msPerspective"];for(var c in b)if(void 0!==a.style[b[c]])return d.pfx=b[c].replace("Perspective","").toLowerCase(),d.prop="-"+d.pfx+"-transform",!0;return!1}(),d.ensureAnimationEnd="",""!==d.vars.controlsContainer&&(d.controlsContainer=a(d.vars.controlsContainer).length>0&&a(d.vars.controlsContainer)),""!==d.vars.manualControls&&(d.manualControls=a(d.vars.manualControls).length>0&&a(d.vars.manualControls)),d.vars.randomize&&(d.slides.sort(function(){return Math.round(Math.random())-.5}),d.container.empty().append(d.slides)),d.doMath(),d.setup("init"),d.vars.controlNav&&p.controlNav.setup(),d.vars.directionNav&&p.directionNav.setup(),d.vars.keyboard&&(1===a(d.containerSelector).length||d.vars.multipleKeyboard)&&a(document).bind("keyup",function(a){var b=a.keyCode;if(!d.animating&&(39===b||37===b)){var c=39===b?d.getTarget("next"):37===b?d.getTarget("prev"):!1;d.flexAnimate(c,d.vars.pauseOnAction)}}),d.vars.mousewheel&&d.bind("mousewheel",function(a,b){a.preventDefault();var f=0>b?d.getTarget("next"):d.getTarget("prev");d.flexAnimate(f,d.vars.pauseOnAction)}),d.vars.pausePlay&&p.pausePlay.setup(),d.vars.slideshow&&d.vars.pauseInvisible&&p.pauseInvisible.init(),d.vars.slideshow&&(d.vars.pauseOnHover&&d.hover(function(){d.manualPlay||d.manualPause||d.pause()},function(){d.manualPause||d.manualPlay||d.stopped||d.play()}),d.vars.pauseInvisible&&p.pauseInvisible.isHidden()||(d.vars.initDelay>0?d.startTimeout=setTimeout(d.play,d.vars.initDelay):d.play())),o&&p.asNav.setup(),g&&d.vars.touch&&p.touch(),(!n||n&&d.vars.smoothHeight)&&a(window).bind("resize orientationchange focus",p.resize),d.find("img").attr("draggable","false"),setTimeout(function(){d.vars.start(d)},200)},asNav:{setup:function(){d.asNav=!0,d.animatingTo=Math.floor(d.currentSlide/d.move),d.currentItem=d.currentSlide,d.slides.removeClass(e+"active-slide").eq(d.currentItem).addClass(e+"active-slide"),f?(b._slider=d,d.slides.each(function(){var b=this;b._gesture=new MSGesture,b._gesture.target=b,b.addEventListener("MSPointerDown",function(a){a.preventDefault(),a.currentTarget._gesture&&a.currentTarget._gesture.addPointer(a.pointerId)},!1),b.addEventListener("MSGestureTap",function(b){b.preventDefault();var c=a(this),e=c.index();a(d.vars.asNavFor).data("flexslider").animating||c.hasClass("active")||(d.direction=d.currentItem<e?"next":"prev",d.flexAnimate(e,d.vars.pauseOnAction,!1,!0,!0))})})):d.slides.on(h,function(b){b.preventDefault();var c=a(this),f=c.index(),g=c.offset().left-a(d).scrollLeft();0>=g&&c.hasClass(e+"active-slide")?d.flexAnimate(d.getTarget("prev"),!0):a(d.vars.asNavFor).data("flexslider").animating||c.hasClass(e+"active-slide")||(d.direction=d.currentItem<f?"next":"prev",d.flexAnimate(f,d.vars.pauseOnAction,!1,!0,!0))})}},controlNav:{setup:function(){d.manualControls?p.controlNav.setupManual():p.controlNav.setupPaging()},setupPaging:function(){var f,g,b="thumbnails"===d.vars.controlNav?"control-thumbs":"control-paging",c=1;if(d.controlNavScaffold=a('<ol class="'+e+"control-nav "+e+b+'"></ol>'),d.pagingCount>1)for(var j=0;j<d.pagingCount;j++){if(g=d.slides.eq(j),f="thumbnails"===d.vars.controlNav?'<img src="'+g.attr("data-thumb")+'"/>':"<a>"+c+"</a>","thumbnails"===d.vars.controlNav&&!0===d.vars.thumbCaptions){var k=g.attr("data-thumbcaption");""!=k&&void 0!=k&&(f+='<span class="'+e+'caption">'+k+"</span>")}d.controlNavScaffold.append("<li>"+f+"</li>"),c++}d.controlsContainer?a(d.controlsContainer).append(d.controlNavScaffold):d.append(d.controlNavScaffold),p.controlNav.set(),p.controlNav.active(),d.controlNavScaffold.delegate("a, img",h,function(b){if(b.preventDefault(),""===i||i===b.type){var c=a(this),f=d.controlNav.index(c);c.hasClass(e+"active")||(d.direction=f>d.currentSlide?"next":"prev",d.flexAnimate(f,d.vars.pauseOnAction))}""===i&&(i=b.type),p.setToClearWatchedEvent()})},setupManual:function(){d.controlNav=d.manualControls,p.controlNav.active(),d.controlNav.bind(h,function(b){if(b.preventDefault(),""===i||i===b.type){var c=a(this),f=d.controlNav.index(c);c.hasClass(e+"active")||(d.direction=f>d.currentSlide?"next":"prev",d.flexAnimate(f,d.vars.pauseOnAction))}""===i&&(i=b.type),p.setToClearWatchedEvent()})},set:function(){var b="thumbnails"===d.vars.controlNav?"img":"a";d.controlNav=a("."+e+"control-nav li "+b,d.controlsContainer?d.controlsContainer:d)},active:function(){d.controlNav.removeClass(e+"active").eq(d.animatingTo).addClass(e+"active")},update:function(b,c){d.pagingCount>1&&"add"===b?d.controlNavScaffold.append(a("<li><a>"+d.count+"</a></li>")):1===d.pagingCount?d.controlNavScaffold.find("li").remove():d.controlNav.eq(c).closest("li").remove(),p.controlNav.set(),d.pagingCount>1&&d.pagingCount!==d.controlNav.length?d.update(c,b):p.controlNav.active()}},directionNav:{setup:function(){var b=a('<ul class="'+e+'direction-nav"><li><a class="'+e+'prev" href="#">'+d.vars.prevText+'</a></li><li><a class="'+e+'next" href="#">'+d.vars.nextText+"</a></li></ul>");d.controlsContainer?(a(d.controlsContainer).append(b),d.directionNav=a("."+e+"direction-nav li a",d.controlsContainer)):(d.append(b),d.directionNav=a("."+e+"direction-nav li a",d)),p.directionNav.update(),d.directionNav.bind(h,function(b){b.preventDefault();var c;(""===i||i===b.type)&&(c=a(this).hasClass(e+"next")?d.getTarget("next"):d.getTarget("prev"),d.flexAnimate(c,d.vars.pauseOnAction)),""===i&&(i=b.type),p.setToClearWatchedEvent()})},update:function(){var a=e+"disabled";1===d.pagingCount?d.directionNav.addClass(a).attr("tabindex","-1"):d.vars.animationLoop?d.directionNav.removeClass(a).removeAttr("tabindex"):0===d.animatingTo?d.directionNav.removeClass(a).filter("."+e+"prev").addClass(a).attr("tabindex","-1"):d.animatingTo===d.last?d.directionNav.removeClass(a).filter("."+e+"next").addClass(a).attr("tabindex","-1"):d.directionNav.removeClass(a).removeAttr("tabindex")}},pausePlay:{setup:function(){var b=a('<div class="'+e+'pauseplay"><a></a></div>');d.controlsContainer?(d.controlsContainer.append(b),d.pausePlay=a("."+e+"pauseplay a",d.controlsContainer)):(d.append(b),d.pausePlay=a("."+e+"pauseplay a",d)),p.pausePlay.update(d.vars.slideshow?e+"pause":e+"play"),d.pausePlay.bind(h,function(b){b.preventDefault(),(""===i||i===b.type)&&(a(this).hasClass(e+"pause")?(d.manualPause=!0,d.manualPlay=!1,d.pause()):(d.manualPause=!1,d.manualPlay=!0,d.play())),""===i&&(i=b.type),p.setToClearWatchedEvent()})},update:function(a){"play"===a?d.pausePlay.removeClass(e+"pause").addClass(e+"play").html(d.vars.playText):d.pausePlay.removeClass(e+"play").addClass(e+"pause").html(d.vars.pauseText)}},touch:function(){function r(f){d.animating?f.preventDefault():(window.navigator.msPointerEnabled||1===f.touches.length)&&(d.pause(),g=k?d.h:d.w,i=Number(new Date),o=f.touches[0].pageX,p=f.touches[0].pageY,e=m&&l&&d.animatingTo===d.last?0:m&&l?d.limit-(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo:m&&d.currentSlide===d.last?d.limit:m?(d.itemW+d.vars.itemMargin)*d.move*d.currentSlide:l?(d.last-d.currentSlide+d.cloneOffset)*g:(d.currentSlide+d.cloneOffset)*g,a=k?p:o,c=k?o:p,b.addEventListener("touchmove",s,!1),b.addEventListener("touchend",t,!1))}function s(b){o=b.touches[0].pageX,p=b.touches[0].pageY,h=k?a-p:a-o,j=k?Math.abs(h)<Math.abs(o-c):Math.abs(h)<Math.abs(p-c);var f=500;(!j||Number(new Date)-i>f)&&(b.preventDefault(),!n&&d.transitions&&(d.vars.animationLoop||(h/=0===d.currentSlide&&0>h||d.currentSlide===d.last&&h>0?Math.abs(h)/g+2:1),d.setProps(e+h,"setTouch")))}function t(){if(b.removeEventListener("touchmove",s,!1),d.animatingTo===d.currentSlide&&!j&&null!==h){var k=l?-h:h,m=k>0?d.getTarget("next"):d.getTarget("prev");d.canAdvance(m)&&(Number(new Date)-i<550&&Math.abs(k)>50||Math.abs(k)>g/2)?d.flexAnimate(m,d.vars.pauseOnAction):n||d.flexAnimate(d.currentSlide,d.vars.pauseOnAction,!0)}b.removeEventListener("touchend",t,!1),a=null,c=null,h=null,e=null}function u(a){a.stopPropagation(),d.animating?a.preventDefault():(d.pause(),b._gesture.addPointer(a.pointerId),q=0,g=k?d.h:d.w,i=Number(new Date),e=m&&l&&d.animatingTo===d.last?0:m&&l?d.limit-(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo:m&&d.currentSlide===d.last?d.limit:m?(d.itemW+d.vars.itemMargin)*d.move*d.currentSlide:l?(d.last-d.currentSlide+d.cloneOffset)*g:(d.currentSlide+d.cloneOffset)*g)}function v(a){a.stopPropagation();var c=a.target._slider;if(c){var d=-a.translationX,f=-a.translationY;return q+=k?f:d,h=q,j=k?Math.abs(q)<Math.abs(-d):Math.abs(q)<Math.abs(-f),a.detail===a.MSGESTURE_FLAG_INERTIA?(setImmediate(function(){b._gesture.stop()}),void 0):((!j||Number(new Date)-i>500)&&(a.preventDefault(),!n&&c.transitions&&(c.vars.animationLoop||(h=q/(0===c.currentSlide&&0>q||c.currentSlide===c.last&&q>0?Math.abs(q)/g+2:1)),c.setProps(e+h,"setTouch"))),void 0)}}function w(b){b.stopPropagation();var d=b.target._slider;if(d){if(d.animatingTo===d.currentSlide&&!j&&null!==h){var f=l?-h:h,k=f>0?d.getTarget("next"):d.getTarget("prev");d.canAdvance(k)&&(Number(new Date)-i<550&&Math.abs(f)>50||Math.abs(f)>g/2)?d.flexAnimate(k,d.vars.pauseOnAction):n||d.flexAnimate(d.currentSlide,d.vars.pauseOnAction,!0)}a=null,c=null,h=null,e=null,q=0}}var a,c,e,g,h,i,j=!1,o=0,p=0,q=0;f?(b.style.msTouchAction="none",b._gesture=new MSGesture,b._gesture.target=b,b.addEventListener("MSPointerDown",u,!1),b._slider=d,b.addEventListener("MSGestureChange",v,!1),b.addEventListener("MSGestureEnd",w,!1)):b.addEventListener("touchstart",r,!1)},resize:function(){!d.animating&&d.is(":visible")&&(m||d.doMath(),n?p.smoothHeight():m?(d.slides.width(d.computedW),d.update(d.pagingCount),d.setProps()):k?(d.viewport.height(d.h),d.setProps(d.h,"setTotal")):(d.vars.smoothHeight&&p.smoothHeight(),d.newSlides.width(d.computedW),d.setProps(d.computedW,"setTotal")))},smoothHeight:function(a){if(!k||n){var b=n?d:d.viewport;a?b.animate({height:d.slides.eq(d.animatingTo).height()},a):b.height(d.slides.eq(d.animatingTo).height())}},sync:function(b){var c=a(d.vars.sync).data("flexslider"),e=d.animatingTo;switch(b){case"animate":c.flexAnimate(e,d.vars.pauseOnAction,!1,!0);break;case"play":c.playing||c.asNav||c.play();break;case"pause":c.pause()}},uniqueID:function(b){return b.find("[id]").each(function(){var b=a(this);b.attr("id",b.attr("id")+"_clone")}),b},pauseInvisible:{visProp:null,init:function(){var a=["webkit","moz","ms","o"];if("hidden"in document)return"hidden";for(var b=0;b<a.length;b++)a[b]+"Hidden"in document&&(p.pauseInvisible.visProp=a[b]+"Hidden");if(p.pauseInvisible.visProp){var c=p.pauseInvisible.visProp.replace(/[H|h]idden/,"")+"visibilitychange";document.addEventListener(c,function(){p.pauseInvisible.isHidden()?d.startTimeout?clearTimeout(d.startTimeout):d.pause():d.started?d.play():d.vars.initDelay>0?setTimeout(d.play,d.vars.initDelay):d.play()})}},isHidden:function(){return document[p.pauseInvisible.visProp]||!1}},setToClearWatchedEvent:function(){clearTimeout(j),j=setTimeout(function(){i=""},3e3)}},d.flexAnimate=function(b,c,f,h,i){if(d.vars.animationLoop||b===d.currentSlide||(d.direction=b>d.currentSlide?"next":"prev"),o&&1===d.pagingCount&&(d.direction=d.currentItem<b?"next":"prev"),!d.animating&&(d.canAdvance(b,i)||f)&&d.is(":visible")){if(o&&h){var j=a(d.vars.asNavFor).data("flexslider");if(d.atEnd=0===b||b===d.count-1,j.flexAnimate(b,!0,!1,!0,i),d.direction=d.currentItem<b?"next":"prev",j.direction=d.direction,Math.ceil((b+1)/d.visible)-1===d.currentSlide||0===b)return d.currentItem=b,d.slides.removeClass(e+"active-slide").eq(b).addClass(e+"active-slide"),!1;d.currentItem=b,d.slides.removeClass(e+"active-slide").eq(b).addClass(e+"active-slide"),b=Math.floor(b/d.visible)}if(d.animating=!0,d.animatingTo=b,c&&d.pause(),d.vars.before(d),d.syncExists&&!i&&p.sync("animate"),d.vars.controlNav&&p.controlNav.active(),m||d.slides.removeClass(e+"active-slide").eq(b).addClass(e+"active-slide"),d.atEnd=0===b||b===d.last,d.vars.directionNav&&p.directionNav.update(),b===d.last&&(d.vars.end(d),d.vars.animationLoop||d.pause()),n)g?(d.slides.eq(d.currentSlide).css({opacity:0,zIndex:1}),d.slides.eq(b).css({opacity:1,zIndex:2}),d.wrapup(q)):(d.slides.eq(d.currentSlide).css({zIndex:1}).animate({opacity:0},d.vars.animationSpeed,d.vars.easing),d.slides.eq(b).css({zIndex:2}).animate({opacity:1},d.vars.animationSpeed,d.vars.easing,d.wrapup));else{var r,s,t,q=k?d.slides.filter(":first").height():d.computedW;m?(r=d.vars.itemMargin,t=(d.itemW+r)*d.move*d.animatingTo,s=t>d.limit&&1!==d.visible?d.limit:t):s=0===d.currentSlide&&b===d.count-1&&d.vars.animationLoop&&"next"!==d.direction?l?(d.count+d.cloneOffset)*q:0:d.currentSlide===d.last&&0===b&&d.vars.animationLoop&&"prev"!==d.direction?l?0:(d.count+1)*q:l?(d.count-1-b+d.cloneOffset)*q:(b+d.cloneOffset)*q,d.setProps(s,"",d.vars.animationSpeed),d.transitions?(d.vars.animationLoop&&d.atEnd||(d.animating=!1,d.currentSlide=d.animatingTo),d.container.unbind("webkitTransitionEnd transitionend"),d.container.bind("webkitTransitionEnd transitionend",function(){clearTimeout(d.ensureAnimationEnd),d.wrapup(q)}),clearTimeout(d.ensureAnimationEnd),d.ensureAnimationEnd=setTimeout(function(){d.wrapup(q)},d.vars.animationSpeed+100)):d.container.animate(d.args,d.vars.animationSpeed,d.vars.easing,function(){d.wrapup(q)})}d.vars.smoothHeight&&p.smoothHeight(d.vars.animationSpeed)}},d.wrapup=function(a){n||m||(0===d.currentSlide&&d.animatingTo===d.last&&d.vars.animationLoop?d.setProps(a,"jumpEnd"):d.currentSlide===d.last&&0===d.animatingTo&&d.vars.animationLoop&&d.setProps(a,"jumpStart")),d.animating=!1,d.currentSlide=d.animatingTo,d.vars.after(d)},d.animateSlides=function(){!d.animating&&q&&d.flexAnimate(d.getTarget("next"))},d.pause=function(){clearInterval(d.animatedSlides),d.animatedSlides=null,d.playing=!1,d.vars.pausePlay&&p.pausePlay.update("play"),d.syncExists&&p.sync("pause")},d.play=function(){d.playing&&clearInterval(d.animatedSlides),d.animatedSlides=d.animatedSlides||setInterval(d.animateSlides,d.vars.slideshowSpeed),d.started=d.playing=!0,d.vars.pausePlay&&p.pausePlay.update("pause"),d.syncExists&&p.sync("play")},d.stop=function(){d.pause(),d.stopped=!0},d.canAdvance=function(a,b){var c=o?d.pagingCount-1:d.last;return b?!0:o&&d.currentItem===d.count-1&&0===a&&"prev"===d.direction?!0:o&&0===d.currentItem&&a===d.pagingCount-1&&"next"!==d.direction?!1:a!==d.currentSlide||o?d.vars.animationLoop?!0:d.atEnd&&0===d.currentSlide&&a===c&&"next"!==d.direction?!1:d.atEnd&&d.currentSlide===c&&0===a&&"next"===d.direction?!1:!0:!1},d.getTarget=function(a){return d.direction=a,"next"===a?d.currentSlide===d.last?0:d.currentSlide+1:0===d.currentSlide?d.last:d.currentSlide-1},d.setProps=function(a,b,c){var e=function(){var c=a?a:(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo,e=function(){if(m)return"setTouch"===b?a:l&&d.animatingTo===d.last?0:l?d.limit-(d.itemW+d.vars.itemMargin)*d.move*d.animatingTo:d.animatingTo===d.last?d.limit:c;switch(b){case"setTotal":return l?(d.count-1-d.currentSlide+d.cloneOffset)*a:(d.currentSlide+d.cloneOffset)*a;case"setTouch":return l?a:a;case"jumpEnd":return l?a:d.count*a;case"jumpStart":return l?d.count*a:a;default:return a}}();return-1*e+"px"}();d.transitions&&(e=k?"translate3d(0,"+e+",0)":"translate3d("+e+",0,0)",c=void 0!==c?c/1e3+"s":"0s",d.container.css("-"+d.pfx+"-transition-duration",c),d.container.css("transition-duration",c)),d.args[d.prop]=e,(d.transitions||void 0===c)&&d.container.css(d.args),d.container.css("transform",e)},d.setup=function(b){if(n)d.slides.css({width:"100%","float":"left",marginRight:"-100%",position:"relative"}),"init"===b&&(g?d.slides.css({opacity:0,display:"block",webkitTransition:"opacity "+d.vars.animationSpeed/1e3+"s ease",zIndex:1}).eq(d.currentSlide).css({opacity:1,zIndex:2}):d.slides.css({opacity:0,display:"block",zIndex:1}).eq(d.currentSlide).css({zIndex:2}).animate({opacity:1},d.vars.animationSpeed,d.vars.easing)),d.vars.smoothHeight&&p.smoothHeight();else{var c,f;"init"===b&&(d.viewport=a('<div class="'+e+'viewport"></div>').css({overflow:"hidden",position:"relative"}).appendTo(d).append(d.container),d.cloneCount=0,d.cloneOffset=0,l&&(f=a.makeArray(d.slides).reverse(),d.slides=a(f),d.container.empty().append(d.slides))),d.vars.animationLoop&&!m&&(d.cloneCount=2,d.cloneOffset=1,"init"!==b&&d.container.find(".clone").remove(),p.uniqueID(d.slides.first().clone().addClass("clone").attr("aria-hidden","true")).appendTo(d.container),p.uniqueID(d.slides.last().clone().addClass("clone").attr("aria-hidden","true")).prependTo(d.container)),d.newSlides=a(d.vars.selector,d),c=l?d.count-1-d.currentSlide+d.cloneOffset:d.currentSlide+d.cloneOffset,k&&!m?(d.container.height(200*(d.count+d.cloneCount)+"%").css("position","absolute").width("100%"),setTimeout(function(){d.newSlides.css({display:"block"}),d.doMath(),d.viewport.height(d.h),d.setProps(c*d.h,"init")},"init"===b?100:0)):(d.container.width(200*(d.count+d.cloneCount)+"%"),d.setProps(c*d.computedW,"init"),setTimeout(function(){d.doMath(),d.newSlides.css({width:d.computedW,"float":"left",display:"block"}),d.vars.smoothHeight&&p.smoothHeight()},"init"===b?100:0))}m||d.slides.removeClass(e+"active-slide").eq(d.currentSlide).addClass(e+"active-slide"),d.vars.init(d)},d.doMath=function(){var a=d.slides.first(),b=d.vars.itemMargin,c=d.vars.minItems,e=d.vars.maxItems;d.w=void 0===d.viewport?d.width():d.viewport.width(),d.h=a.height(),d.boxPadding=a.outerWidth()-a.width(),m?(d.itemT=d.vars.itemWidth+b,d.minW=c?c*d.itemT:d.w,d.maxW=e?e*d.itemT-b:d.w,d.itemW=d.minW>d.w?(d.w-b*(c-1))/c:d.maxW<d.w?(d.w-b*(e-1))/e:d.vars.itemWidth>d.w?d.w:d.vars.itemWidth,d.visible=Math.floor(d.w/d.itemW),d.move=d.vars.move>0&&d.vars.move<d.visible?d.vars.move:d.visible,d.pagingCount=Math.ceil((d.count-d.visible)/d.move+1),d.last=d.pagingCount-1,d.limit=1===d.pagingCount?0:d.vars.itemWidth>d.w?d.itemW*(d.count-1)+b*(d.count-1):(d.itemW+b)*d.count-d.w-b):(d.itemW=d.w,d.pagingCount=d.count,d.last=d.count-1),d.computedW=d.itemW-d.boxPadding},d.update=function(a,b){d.doMath(),m||(a<d.currentSlide?d.currentSlide+=1:a<=d.currentSlide&&0!==a&&(d.currentSlide-=1),d.animatingTo=d.currentSlide),d.vars.controlNav&&!d.manualControls&&("add"===b&&!m||d.pagingCount>d.controlNav.length?p.controlNav.update("add"):("remove"===b&&!m||d.pagingCount<d.controlNav.length)&&(m&&d.currentSlide>d.last&&(d.currentSlide-=1,d.animatingTo-=1),p.controlNav.update("remove",d.last))),d.vars.directionNav&&p.directionNav.update()},d.addSlide=function(b,c){var e=a(b);d.count+=1,d.last=d.count-1,k&&l?void 0!==c?d.slides.eq(d.count-c).after(e):d.container.prepend(e):void 0!==c?d.slides.eq(c).before(e):d.container.append(e),d.update(c,"add"),d.slides=a(d.vars.selector+":not(.clone)",d),d.setup(),d.vars.added(d)},d.removeSlide=function(b){var c=isNaN(b)?d.slides.index(a(b)):b;d.count-=1,d.last=d.count-1,isNaN(b)?a(b,d.slides).remove():k&&l?d.slides.eq(d.last).remove():d.slides.eq(b).remove(),d.doMath(),d.update(c,"remove"),d.slides=a(d.vars.selector+":not(.clone)",d),d.setup(),d.vars.removed(d)},p.init()},a(window).blur(function(){focused=!1}).focus(function(){focused=!0}),a.flexslider.defaults={namespace:"flex-",selector:".slides > li",animation:"fade",easing:"swing",direction:"horizontal",reverse:!1,animationLoop:!0,smoothHeight:!1,startAt:0,slideshow:!0,slideshowSpeed:7e3,animationSpeed:600,initDelay:0,randomize:!1,thumbCaptions:!1,pauseOnAction:!0,pauseOnHover:!1,pauseInvisible:!0,useCSS:!0,touch:!0,video:!1,controlNav:!0,directionNav:!0,prevText:"Previous",nextText:"Next",keyboard:!0,multipleKeyboard:!1,mousewheel:!1,pausePlay:!1,pauseText:"Pause",playText:"Play",controlsContainer:"",manualControls:"",sync:"",asNavFor:"",itemWidth:0,itemMargin:0,minItems:1,maxItems:0,move:0,allowOneSlide:!0,start:function(){},before:function(){},after:function(){},end:function(){},added:function(){},removed:function(){},init:function(){}},a.fn.flexslider=function(b){if(void 0===b&&(b={}),"object"==typeof b)return this.each(function(){var c=a(this),d=b.selector?b.selector:".slides > li",e=c.find(d);1===e.length&&b.allowOneSlide===!0||0===e.length?(e.fadeIn(400),b.start&&b.start(c)):void 0===c.data("flexslider")&&new a.flexslider(this,b)});var c=a(this).data("flexslider");switch(b){case"play":c.play();break;case"pause":c.pause();break;case"stop":c.stop();break;case"next":c.flexAnimate(c.getTarget("next"),!0);break;case"prev":case"previous":c.flexAnimate(c.getTarget("prev"),!0);break;default:"number"==typeof b&&c.flexAnimate(b,!0)}}}(jQuery);

/*!
	Zoom v1.7.13 - 2014-04-29
	Enlarge images on click or mouseover.
	(c) 2014 Jack Moore - http://www.jacklmoore.com/zoom
	license: http://www.opensource.org/licenses/mit-license.php
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,m,l,r,s,f=o(t).css("position"),h=o(n);return t.style.position=/(absolute|fixed)/.test(f)?f:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=o(t).outerWidth(),u=o(t).outerHeight(),n===t?(m=c,a=u):(m=h.outerWidth(),a=h.outerHeight()),l=(e.width-c)/m,r=(e.height-u)/a,s=h.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,m),0),e.style.left=t*-l+"px",e.style.top=n*-r+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e,i=o.extend({},t,n||{}),u=i.target||this,c=this,a=o(c),m=document.createElement("img"),l=o(m),r="mousemove.zoom",s=!1,f=!1;(i.url||(e=a.find("img"),e[0]&&(i.url=e.data("src")||e.attr("src")),i.url))&&(function(){var o=u.style.position,t=u.style.overflow;a.one("zoom.destroy",function(){a.off(".zoom"),u.style.position=o,u.style.overflow=t,l.remove()})}(),m.onload=function(){function t(t){e.init(),e.move(t),l.stop().fadeTo(o.support.opacity?i.duration:0,1,o.isFunction(i.onZoomIn)?i.onZoomIn.call(m):!1)}function n(){l.stop().fadeTo(i.duration,0,o.isFunction(i.onZoomOut)?i.onZoomOut.call(m):!1)}var e=o.zoom(u,c,m,i.magnify);"grab"===i.on?a.on("mousedown.zoom",function(i){1===i.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(r,e.move)}),t(i),o(document).on(r,e.move),i.preventDefault())}):"click"===i.on?a.on("click.zoom",function(i){return s?void 0:(s=!0,t(i),o(document).on(r,e.move),o(document).one("click.zoom",function(){n(),s=!1,o(document).off(r,e.move)}),!1)}):"toggle"===i.on?a.on("click.zoom",function(o){s?n():t(o),s=!s}):"mouseover"===i.on&&(e.init(),a.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(r,e.move)),i.touch&&a.on("touchstart.zoom",function(o){o.preventDefault(),f?(f=!1,n()):(f=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),e.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}),o.isFunction(i.callback)&&i.callback.call(m)},m.src=i.url)})},o.fn.zoom.defaults=t})(window.jQuery);

/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
;(function(){function n(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function t(n,t,r){for(var e=-1,u=n.length;++e<u;){var o=n[e],i=t(o);if(null!=i&&(c===an?i===i:r(i,c)))var c=i,f=o}return f}function r(n,t,r){var e;return r(n,function(n,r,u){return t(n,r,u)?(e=n,false):void 0}),e}function e(n,t,r,e,u){return u(n,function(n,u,o){r=e?(e=false,n):t(r,n,u,o)}),r}function u(n,t){return O(t,function(t){return n[t]})}function o(n){return n&&n.Object===Object?n:null}function i(n){return vn[n];
}function c(n){var t=false;if(null!=n&&typeof n.toString!="function")try{t=!!(n+"")}catch(r){}return t}function f(n,t){return n=typeof n=="number"||hn.test(n)?+n:-1,n>-1&&0==n%1&&(null==t?9007199254740991:t)>n}function a(n){if(Y(n)&&!Pn(n)){if(n instanceof l)return n;if(En.call(n,"__wrapped__")){var t=new l(n.__wrapped__,n.__chain__);return t.__actions__=N(n.__actions__),t}}return new l(n)}function l(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t}function p(n,t,r,e){var u;return(u=n===an)||(u=xn[r],
u=(n===u||n!==n&&u!==u)&&!En.call(e,r)),u?t:n}function s(n){return X(n)?Fn(n):{}}function h(n,t,r){if(typeof n!="function")throw new TypeError("Expected a function");return setTimeout(function(){n.apply(an,r)},t)}function v(n,t){var r=true;return $n(n,function(n,e,u){return r=!!t(n,e,u)}),r}function y(n,t){var r=[];return $n(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function _(t,r,e,u){u||(u=[]);for(var o=-1,i=t.length;++o<i;){var c=t[o];r>0&&Y(c)&&L(c)&&(e||Pn(c)||K(c))?r>1?_(c,r-1,e,u):n(u,c):e||(u[u.length]=c);
}return u}function g(n,t){return n&&qn(n,t,en)}function b(n,t){return y(t,function(t){return Q(n[t])})}function j(n,t,r,e,u){return n===t?true:null==n||null==t||!X(n)&&!Y(t)?n!==n&&t!==t:m(n,t,j,r,e,u)}function m(n,t,r,e,u,o){var i=Pn(n),f=Pn(t),a="[object Array]",l="[object Array]";i||(a=kn.call(n),"[object Arguments]"==a&&(a="[object Object]")),f||(l=kn.call(t),"[object Arguments]"==l&&(l="[object Object]"));var p="[object Object]"==a&&!c(n),f="[object Object]"==l&&!c(t);return!(l=a==l)||i||p?2&u||(a=p&&En.call(n,"__wrapped__"),
f=f&&En.call(t,"__wrapped__"),!a&&!f)?l?(o||(o=[]),(a=J(o,function(t){return t[0]===n}))&&a[1]?a[1]==t:(o.push([n,t]),t=(i?I:q)(n,t,r,e,u,o),o.pop(),t)):false:r(a?n.value():n,f?t.value():t,e,u,o):$(n,t,a)}function d(n){var t=typeof n;return"function"==t?n:null==n?cn:("object"==t?x:A)(n)}function w(n){n=null==n?n:Object(n);var t,r=[];for(t in n)r.push(t);return r}function O(n,t){var r=-1,e=L(n)?Array(n.length):[];return $n(n,function(n,u,o){e[++r]=t(n,u,o)}),e}function x(n){var t=en(n);return function(r){
var e=t.length;if(null==r)return!e;for(r=Object(r);e--;){var u=t[e];if(!(u in r&&j(n[u],r[u],an,3)))return false}return true}}function E(n,t){return n=Object(n),P(t,function(t,r){return r in n&&(t[r]=n[r]),t},{})}function A(n){return function(t){return null==t?an:t[n]}}function k(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Array(u);++e<u;)r[e]=n[e+t];return r}function N(n){return k(n,0,n.length)}function S(n,t){var r;return $n(n,function(n,e,u){return r=t(n,e,u),
!r}),!!r}function T(t,r){return P(r,function(t,r){return r.func.apply(r.thisArg,n([t],r.args))},t)}function F(n,t,r,e){r||(r={});for(var u=-1,o=t.length;++u<o;){var i=t[u],c=e?e(r[i],n[i],i,r,n):n[i],f=r,a=f[i];En.call(f,i)&&(a===c||a!==a&&c!==c)&&(c!==an||i in f)||(f[i]=c)}return r}function R(n){return V(function(t,r){var e=-1,u=r.length,o=u>1?r[u-1]:an,o=typeof o=="function"?(u--,o):an;for(t=Object(t);++e<u;){var i=r[e];i&&n(t,i,e,o)}return t})}function B(n){return function(){var t=arguments,r=s(n.prototype),t=n.apply(r,t);
return X(t)?t:r}}function D(n,t,r){function e(){for(var o=-1,i=arguments.length,c=-1,f=r.length,a=Array(f+i),l=this&&this!==wn&&this instanceof e?u:n;++c<f;)a[c]=r[c];for(;i--;)a[c++]=arguments[++o];return l.apply(t,a)}if(typeof n!="function")throw new TypeError("Expected a function");var u=B(n);return e}function I(n,t,r,e,u,o){var i=-1,c=1&u,f=n.length,a=t.length;if(f!=a&&!(2&u&&a>f))return false;for(a=true;++i<f;){var l=n[i],p=t[i];if(void 0!==an){a=false;break}if(c){if(!S(t,function(n){return l===n||r(l,n,e,u,o);
})){a=false;break}}else if(l!==p&&!r(l,p,e,u,o)){a=false;break}}return a}function $(n,t,r){switch(r){case"[object Boolean]":case"[object Date]":return+n==+t;case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object Number]":return n!=+n?t!=+t:n==+t;case"[object RegExp]":case"[object String]":return n==t+""}return false}function q(n,t,r,e,u,o){var i=2&u,c=en(n),f=c.length,a=en(t).length;if(f!=a&&!i)return false;for(var l=f;l--;){var p=c[l];if(!(i?p in t:En.call(t,p)))return false}for(a=true;++l<f;){
var p=c[l],s=n[p],h=t[p];if(void 0!==an||s!==h&&!r(s,h,e,u,o)){a=false;break}i||(i="constructor"==p)}return a&&!i&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(a=false)),a}function z(n){var t=n?n.length:an;if(W(t)&&(Pn(n)||nn(n)||K(n))){n=String;for(var r=-1,e=Array(t);++r<t;)e[r]=n(r);t=e}else t=null;return t}function C(n){var t=n&&n.constructor,t=Q(t)&&t.prototype||xn;return n===t}function G(n){
return n?n[0]:an}function J(n,t){return r(n,d(t),$n)}function M(n,t){return $n(n,typeof t=="function"?t:cn)}function P(n,t,r){return e(n,d(t),r,3>arguments.length,$n)}function U(n,t){var r;if(typeof t!="function")throw new TypeError("Expected a function");return n=Un(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=an),r}}function V(n){var t;if(typeof n!="function")throw new TypeError("Expected a function");return t=In(t===an?n.length-1:Un(t),0),function(){for(var r=arguments,e=-1,u=In(r.length-t,0),o=Array(u);++e<u;)o[e]=r[t+e];
for(u=Array(t+1),e=-1;++e<t;)u[e]=r[e];return u[t]=o,n.apply(this,u)}}function H(n,t){return n>t}function K(n){return Y(n)&&L(n)&&En.call(n,"callee")&&(!Rn.call(n,"callee")||"[object Arguments]"==kn.call(n))}function L(n){return null!=n&&!(typeof n=="function"&&Q(n))&&W(zn(n))}function Q(n){return n=X(n)?kn.call(n):"","[object Function]"==n||"[object GeneratorFunction]"==n}function W(n){return typeof n=="number"&&n>-1&&0==n%1&&9007199254740991>=n}function X(n){var t=typeof n;return!!n&&("object"==t||"function"==t);
}function Y(n){return!!n&&typeof n=="object"}function Z(n){return typeof n=="number"||Y(n)&&"[object Number]"==kn.call(n)}function nn(n){return typeof n=="string"||!Pn(n)&&Y(n)&&"[object String]"==kn.call(n)}function tn(n,t){return t>n}function rn(n){return typeof n=="string"?n:null==n?"":n+""}function en(n){var t=C(n);if(!t&&!L(n))return Dn(Object(n));var r,e=z(n),u=!!e,e=e||[],o=e.length;for(r in n)!En.call(n,r)||u&&("length"==r||f(r,o))||t&&"constructor"==r||e.push(r);return e}function un(n){for(var t=-1,r=C(n),e=w(n),u=e.length,o=z(n),i=!!o,o=o||[],c=o.length;++t<u;){
var a=e[t];i&&("length"==a||f(a,c))||"constructor"==a&&(r||!En.call(n,a))||o.push(a)}return o}function on(n){return n?u(n,en(n)):[]}function cn(n){return n}function fn(t,r,e){var u=en(r),o=b(r,u);null!=e||X(r)&&(o.length||!u.length)||(e=r,r=t,t=this,o=b(r,en(r)));var i=X(e)&&"chain"in e?e.chain:true,c=Q(t);return $n(o,function(e){var u=r[e];t[e]=u,c&&(t.prototype[e]=function(){var r=this.__chain__;if(i||r){var e=t(this.__wrapped__);return(e.__actions__=N(this.__actions__)).push({func:u,args:arguments,
thisArg:t}),e.__chain__=r,e}return u.apply(t,n([this.value()],arguments))})}),t}var an,ln=1/0,pn=/[&<>"'`]/g,sn=RegExp(pn.source),hn=/^(?:0|[1-9]\d*)$/,vn={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"},yn={"function":true,object:true},_n=yn[typeof exports]&&exports&&!exports.nodeType?exports:an,gn=yn[typeof module]&&module&&!module.nodeType?module:an,bn=gn&&gn.exports===_n?_n:an,jn=o(yn[typeof self]&&self),mn=o(yn[typeof window]&&window),dn=o(yn[typeof this]&&this),wn=o(_n&&gn&&typeof global=="object"&&global)||mn!==(dn&&dn.window)&&mn||jn||dn||Function("return this")(),On=Array.prototype,xn=Object.prototype,En=xn.hasOwnProperty,An=0,kn=xn.toString,Nn=wn._,Sn=wn.Reflect,Tn=Sn?Sn.f:an,Fn=Object.create,Rn=xn.propertyIsEnumerable,Bn=wn.isFinite,Dn=Object.keys,In=Math.max,$n=function(n,t){
return function(r,e){if(null==r)return r;if(!L(r))return n(r,e);for(var u=r.length,o=t?u:-1,i=Object(r);(t?o--:++o<u)&&false!==e(i[o],o,i););return r}}(g),qn=function(n){return function(t,r,e){var u=-1,o=Object(t);e=e(t);for(var i=e.length;i--;){var c=e[n?i:++u];if(false===r(o[c],c,o))break}return t}}();Tn&&!Rn.call({valueOf:1},"valueOf")&&(w=function(n){n=Tn(n);for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r});var zn=A("length"),Cn=V(function(t,r){return Pn(t)||(t=null==t?[]:[Object(t)]),_(r,1),
n(N(t),on)}),Gn=V(function(n,t,r){return D(n,t,r)}),Jn=V(function(n,t){return h(n,1,t)}),Mn=V(function(n,t,r){return h(n,Vn(t)||0,r)}),Pn=Array.isArray,Un=Number,Vn=Number,Hn=R(function(n,t){F(t,en(t),n)}),Kn=R(function(n,t){F(t,un(t),n)}),Ln=R(function(n,t,r,e){F(t,un(t),n,e)}),Qn=V(function(n){return n.push(an,p),Ln.apply(an,n)}),Wn=V(function(n,t){return null==n?{}:E(n,_(t,1))}),Xn=d;l.prototype=s(a.prototype),l.prototype.constructor=l,a.assignIn=Kn,a.before=U,a.bind=Gn,a.chain=function(n){return n=a(n),
n.__chain__=true,n},a.compact=function(n){return y(n,Boolean)},a.concat=Cn,a.create=function(n,t){var r=s(n);return t?Hn(r,t):r},a.defaults=Qn,a.defer=Jn,a.delay=Mn,a.filter=function(n,t){return y(n,d(t))},a.flatten=function(n){return n&&n.length?_(n,1):[]},a.flattenDeep=function(n){return n&&n.length?_(n,ln):[]},a.iteratee=Xn,a.keys=en,a.map=function(n,t){return O(n,d(t))},a.matches=function(n){return x(Hn({},n))},a.mixin=fn,a.negate=function(n){if(typeof n!="function")throw new TypeError("Expected a function");
return function(){return!n.apply(this,arguments)}},a.once=function(n){return U(2,n)},a.pick=Wn,a.slice=function(n,t,r){var e=n?n.length:0;return r=r===an?e:+r,e?k(n,null==t?0:+t,r):[]},a.sortBy=function(n,t){var r=0;return t=d(t),O(O(n,function(n,e,u){return{c:n,b:r++,a:t(n,e,u)}}).sort(function(n,t){var r;n:{r=n.a;var e=t.a;if(r!==e){var u=null===r,o=r===an,i=r===r,c=null===e,f=e===an,a=e===e;if(r>e&&!c||!i||u&&!f&&a||o&&a){r=1;break n}if(e>r&&!u||!a||c&&!o&&i||f&&i){r=-1;break n}}r=0}return r||n.b-t.b;
}),A("c"))},a.tap=function(n,t){return t(n),n},a.thru=function(n,t){return t(n)},a.toArray=function(n){return L(n)?n.length?N(n):[]:on(n)},a.values=on,a.extend=Kn,fn(a,a),a.clone=function(n){return X(n)?Pn(n)?N(n):F(n,en(n)):n},a.escape=function(n){return(n=rn(n))&&sn.test(n)?n.replace(pn,i):n},a.every=function(n,t,r){return t=r?an:t,v(n,d(t))},a.find=J,a.forEach=M,a.has=function(n,t){return null!=n&&En.call(n,t)},a.head=G,a.identity=cn,a.indexOf=function(n,t,r){var e=n?n.length:0;r=typeof r=="number"?0>r?In(e+r,0):r:0,
r=(r||0)-1;for(var u=t===t;++r<e;){var o=n[r];if(u?o===t:o!==o)return r}return-1},a.isArguments=K,a.isArray=Pn,a.isBoolean=function(n){return true===n||false===n||Y(n)&&"[object Boolean]"==kn.call(n)},a.isDate=function(n){return Y(n)&&"[object Date]"==kn.call(n)},a.isEmpty=function(n){if(L(n)&&(Pn(n)||nn(n)||Q(n.splice)||K(n)))return!n.length;for(var t in n)if(En.call(n,t))return false;return true},a.isEqual=function(n,t){return j(n,t)},a.isFinite=function(n){return typeof n=="number"&&Bn(n)},a.isFunction=Q,a.isNaN=function(n){
return Z(n)&&n!=+n},a.isNull=function(n){return null===n},a.isNumber=Z,a.isObject=X,a.isRegExp=function(n){return X(n)&&"[object RegExp]"==kn.call(n)},a.isString=nn,a.isUndefined=function(n){return n===an},a.last=function(n){var t=n?n.length:0;return t?n[t-1]:an},a.max=function(n){return n&&n.length?t(n,cn,H):an},a.min=function(n){return n&&n.length?t(n,cn,tn):an},a.noConflict=function(){return wn._===this&&(wn._=Nn),this},a.noop=function(){},a.reduce=P,a.result=function(n,t,r){return t=null==n?an:n[t],
t===an&&(t=r),Q(t)?t.call(n):t},a.size=function(n){return null==n?0:(n=L(n)?n:en(n),n.length)},a.some=function(n,t,r){return t=r?an:t,S(n,d(t))},a.uniqueId=function(n){var t=++An;return rn(n)+t},a.each=M,a.first=G,fn(a,function(){var n={};return g(a,function(t,r){En.call(a.prototype,r)||(n[r]=t)}),n}(),{chain:false}),a.VERSION="4.5.1",$n("pop join replace reverse split push shift sort splice unshift".split(" "),function(n){var t=(/^(?:replace|split)$/.test(n)?String.prototype:On)[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|join|replace|shift)$/.test(n);
a.prototype[n]=function(){var n=arguments;return e&&!this.__chain__?t.apply(this.value(),n):this[r](function(r){return t.apply(r,n)})}}),a.prototype.toJSON=a.prototype.valueOf=a.prototype.value=function(){return T(this.__wrapped__,this.__actions__)},(mn||jn||{})._=a,typeof define=="function"&&typeof define.amd=="object"&&define.amd? define(function(){return a}):_n&&gn?(bn&&((gn.exports=a)._=a),_n._=a):wn._=a}).call(this);

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) return;

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.originalEvent.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.originalEvent.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});


/* ================ MODULES ================ */
theme.Hero = (function() {
  theme.sliders = function(slider, sectionId) {
    this.$slider = $(slider);
    this.$sliderContainer = this.$slider.parent();
    this.sectionId = sectionId;
    this.selectors = {
      slide: '[data-slider-item]',
      activeSlide: '.flex-active-slide',
      navigationButton: '[data-slider-navigation]',
      previousArrow: '[data-slider-prev]',
      pauseButton: '[data-slider-pause]',
      textContentMobile: '[data-text-mobile]',
      indicatorDotsContainer: '.flex-control-nav',
      hideSlideClass: 'slide-hide'
    };
    $.extend(theme.strings, {
      loadSlideA11yString: this.$slider.data('slide-nav-a11y'),
      activeSlideA11yString: this.$slider.data('slide-nav-active-a11y')
    });
    this.sliderArgs = {
      animation: this.$slider.data('transition'),
      animationSpeed: 500,
      pauseOnHover: true,
      keyboard: false,
      slideshow: this.$slider.data('autoplay'),
      slideshowSpeed: this.$slider.data('speed'),
      controlNav: true,
      directionNav: false,
      smoothHeight: false,
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      controlsContainer: this.$sliderContainer.find('[data-slider-controls]'),
      before: function(slider) {
        var $slider = $(slider);
        $slider.resize();
        $slider
          .find(this.selectors.slide)
          .not(this.selectors.activeSlide)
          .removeClass(this.selectors.hideSlideClass);

        this.showMobileText(slider.animatingTo);
      }.bind(this),
      start: function(slider) {
        this.slideshowA11y(slider);
      }.bind(this),
      after: function(slider) {
        var $slider = $(slider);
        var $slides = $slider.find(this.selectors.slide);
        var $activeSlide = $slider.find(this.selectors.activeSlide);
        var $indicatorDots = this.$sliderContainer.find(
          this.selectors.indicatorDotsContainer + ' a'
        );
        var currentSlide = slider.currentSlide;

        $slider
          .find(this.selectors.slide)
          .not(this.selectors.activeSlide)
          .addClass(this.selectors.hideSlideClass);
        $slider.resize();

        $slides.attr('aria-hidden', true);
        $activeSlide.attr('aria-hidden', false);

        $indicatorDots.each(function(index) {
          var $element = $(this);
          $element.attr('aria-label', slideLabel(currentSlide, index));
          if (index === currentSlide) {
            $element.attr('aria-current', true);
          } else {
            $element.removeAttr('aria-current');
          }
        });
      }.bind(this),
      init: function(slider) {
        var $slider = $(slider);
        var previousArrow = this.selectors.previousArrow;
        $slider
          .find(this.selectors.activeSlide)
          .removeClass(this.selectors.hideSlideClass);

        this.$sliderContainer
          .find(this.selectors.navigationButton)
          .on('click keyup', function(evt) {
            if (
              evt.type === 'keyup' &&
              !(evt.keyCode === '13' || evt.keyCode === '32')
            ) {
              return;
            }
            if ($(this).is(previousArrow)) {
              $slider.flexslider('prev');
            } else {
              $slider.flexslider('next');
            }
          });

        if (this.sliderArgs.slideshow) {
          var $pauseButton = this.$sliderContainer.find(
            this.selectors.pauseButton
          );
          var pausedClass = 'is-paused';

          $pauseButton.on('click', function() {
            var $element = $(this);
            var isPaused = $element.hasClass(pausedClass);

            $element.toggleClass(pausedClass, !isPaused).attr({
              'aria-label': isPaused
                ? $element.data('label-pause')
                : $element.data('label-play'),
              'aria-pressed': !isPaused
            });

            if (isPaused) {
              $slider.flexslider('play');
            } else {
              $slider.flexslider('pause');
            }
          });
        }
      }.bind(this)
    };

    this.slideshowA11y = function(slider) {
      var $slider = $(slider);
      var $sliderContainer = this.$sliderContainer;
      var $slides = $slider.find(this.selectors.slide);
      var $activeSlide = $slider.find(this.selectors.activeSlide);
      var sectionId = this.sectionId;
      var $indicatorsContainer = $sliderContainer.find(
        this.selectors.indicatorDotsContainer
      );
      var $indicatorDots = $indicatorsContainer.find('a');

      $sliderContainer
        .on('keyup', this.keyboardNavigation.bind(this))
        .on('focusin', function(evt) {
          if (
            $(this).has(evt.target).length &&
            $slider.attr('aria-live') === 'polite'
          ) {
            return;
          }

          $slider.attr('aria-live', 'polite');
        })
        .on('focusout', function(evt) {
          if ($(this).has(evt.relatedTarget).length) {
            return;
          }

          $slider.removeAttr('aria-live');
        });

      $slides.each(function() {
        $(this).attr('aria-hidden', true);
      });

      $activeSlide.attr('aria-hidden', false);

      // Turn off default listeners set by flexslider
      $indicatorsContainer.off('click touchend MSPointerUp keyup', 'a, img');

      $indicatorDots.each(function(index) {
        var $element = $(this);
        $element
          .attr({
            'aria-label': slideLabel(0, index),
            'data-slide-number': index + 1,
            'aria-controls':
              '#' +
              $slides
                .filter(':not(.clone)')
                .eq(index)
                .attr('id'),
            href: '#flexslider--' + sectionId
          })
          .on('keyup click', function(evt) {
            if (evt.type === 'keyup') {
              if (evt.which === 9) {
                evt.stopImmediatePropagation();
              }
              if (evt.which !== 13 && evt.which !== 32) {
                return;
              }
            }

            evt.preventDefault();

            var slideNumber = $(evt.target).data('slide-number') - 1;

            $slider.flexslider(slideNumber);

            if (evt.type === 'keyup' || evt.detail === 0) {
              $sliderContainer.focus();
            }
          });

        if (index === 0) {
          $element.attr('aria-current', true);
        }
      });
    };

    this.showMobileText = function(slideIndex) {
      var $allTextContent = this.$sliderContainer.find(
        this.selectors.textContentMobile
      );
      var $currentTextContent = $allTextContent.filter(
        '[data-mobile-slide-text=' + slideIndex + ']'
      );
      $allTextContent.hide();
      $currentTextContent.show();
    };

    this.keyboardNavigation = function(evt) {
      if (evt.keyCode === 37) {
        this.$slider.flexslider('prev');
      }
      if (evt.keyCode === 39) {
        this.$slider.flexslider('next');
      }
    };

    if (this.$slider.length) {
      if (this.$slider.find('li').length === 1) {
        this.sliderArgs.slideshow = false;
        this.sliderArgs.slideshowSpeed = 0;
        this.sliderArgs.controlNav = false;
        this.sliderArgs.directionNav = false;
        this.sliderArgs.touch = false;
      }

      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      var slideshow = this.$slider.flexslider(this.sliderArgs);

      this.showMobileText(0);

      return slideshow;
    }
  };

  function slideLabel(activeSlideIndex, currentIndex) {
    var label =
      activeSlideIndex === currentIndex
        ? theme.strings.activeSlideA11yString
        : theme.strings.loadSlideA11yString;

    return label.replace('[slide_number]', currentIndex + 1);
  }

  return theme.sliders;
})();


/* ================ Sections ================ */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    this.sectionId = $container.attr('data-section-id');
    this.comingSoon =
      $container.attr('data-product-coming-soon') === 'true';
    this.comingSoonText =
      $container.attr('data-product-coming-soon-text') || 'COMING SOON';

    this.selectors = {
      $html: $('html'),
      $addToCartBtn: $('#AddToCart', this.$container),
      $productPrice: $('#ProductPrice', this.$container),
      $comparePrice: $('#ComparePrice', this.$container),
      $comparePriceA11y: $('#ComparePriceA11y', this.$container),
      $priceA11y: $('#PriceA11y', this.$container),
      $addToCartText: $('#AddToCartText', this.$container),
      $productForm: $('.product-form', this.$container),
      $productImageWrappers: $(
        '.product-single__featured-image-wrapper',
        this.$container
      ),
      $productGalleryStage: $('.product-single__gallery-stage', this.$container),
      $productSinglePhotos: $('.product-single__photos', this.$container),
      $productThumbs: $('#ProductThumbs').find(
        '.product-single__thumbnail',
        this.$container
      ),
      $productGalleryPrev: $('[data-product-gallery-prev]', this.$container),
      $productGalleryNext: $('[data-product-gallery-next]', this.$container),
      $productImageGallery: $('.gallery__item', this.$container),
      $productImageViewer: $('[data-product-image-viewer]', this.$container),
      $productImageViewerClose: $('[data-product-image-viewer-close]', this.$container),
      $productImageViewerItems: $('[data-product-image-viewer-item]', this.$container),
      $productImageViewerThumbnailList: $(
        '[data-product-image-viewer-thumbnails]',
        this.$container
      ),
      $productImageViewerThumbnails: $(
        '[data-product-image-viewer-thumbnail]',
        this.$container
      ),
      $productSizeCharts: $('[data-product-size-chart]', this.$container),
      $productFullDetails: $('.product-single__full-details', this.$container),
      $tabTrigger: $('.tab-switch__trigger', this.$container),
      $tabContent: $('.tab-switch__content', this.$container),
      $SKU: $('.variant-sku', this.$container),
      $shopifyPaymentButton: $('.shopify-payment-button', this.$container),
      $unitPrice: $('[data-unit-price]', this.$container),
      $unitPriceBaseUnit: $('[data-unit-price-base-unit]', this.$container),
      $unitPriceContainer: $('[data-unit-price-container]', this.$container)
    };

    theme.styleTextLinks();

    if (!$('#ProductJson-' + this.sectionId).html()) return;

    this.zoomType = $container.data('image-zoom-type');
    this.showExtraTab = $container.data('show-extra-tab');
    this.extraTabContent = $container.data('extra-tab-content');
    this.cartEnableAjax = $container.data('cart-enable-ajax');
    this.enableHistoryState = $container.data('enable-history-state') || false;

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + this.sectionId).innerHTML
    );

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this.stringOverrides();
      this.initComingSoonState();
      this.initProductVariant();
      this.initBreakpoints();
      this.initThumbnails();
      this.initProductGalleryNav();
      this.initProductGallerySwipe();
      this.initProductImageViewer();
      this.initProductSizeCharts();

      if (this.cartEnableAjax) {
        this.enableAjax();
      }

      if (!theme.variables.bpSmall && this.zoomType === 'lightbox') {
        this.productImageGallery();
      }

      if (!this.showExtraTab || this.extraTabContent) {
        this.initProductTabs();
      }
    },

    onUnload: function() {
      $(window).off('resize.productGalleryNav-' + this.sectionId);
      this.selectors.$productForm.off('.productComingSoon');
      this._closeProductImageViewer(false);
      this.selectors.$productSinglePhotos.off('.productImageViewer');
      this.selectors.$productImageViewerClose.off('.productImageViewer');
      this.selectors.$productImageViewerThumbnails.off('.productImageViewer');
      this.selectors.$productImageViewer.off('.productImageViewer');
      $(document).off('keydown.productImageViewer-' + this.sectionId);

      if (this.productImageViewerScrollFrame) {
        window.cancelAnimationFrame(this.productImageViewerScrollFrame);
        this.productImageViewerScrollFrame = null;
      }
      this.selectors.$productSinglePhotos
        .find('img')
        .off('load.productGalleryNav');
      this.selectors.$productGalleryStage.off('.productGallerySwipe');
      $('.single-option-selector', this.$container).off('.productOptions');
      $('.product-single__color-chart', this.$container).off('.productOptions');
      $('.product-single__size-options', this.$container).off('.productOptions');
      this.$container.off('.productSizeChart');
      $(document).off('.productSizeChart-' + this.sectionId);
      $('body').removeClass('product-size-chart-drawer-open');

      if (this.productSizeChartCloseTimer) {
        window.clearTimeout(this.productSizeChartCloseTimer);
        this.productSizeChartCloseTimer = null;
      }
    },

    stringOverrides: function() {
      // Override defaults in theme.strings with potential
      // template overrides

      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    initComingSoonState: function() {
      if (!this.comingSoon) return;

      this.selectors.$addToCartBtn
        .prop('disabled', true)
        .attr('aria-disabled', 'true');
      this.selectors.$addToCartText.text(this.comingSoonText);
      this.selectors.$shopifyPaymentButton.hide();
      this.selectors.$productForm.on(
        'submit.productComingSoon',
        function(evt) {
          evt.preventDefault();
        }
      );
    },

    initBreakpoints: function() {
      var self = this;
      var zoomType = $('#ProductSection').data('image-zoom-type');

      enquire.register(theme.variables.mediaQuerySmall, {
        match: function() {
          if (zoomType === 'lightbox') {
            // remove event handlers for lightbox on mobile
            self.selectors.$productImageGallery.off();
            self.selectors.$productSinglePhotos
              .find('img')
              .removeClass('lightbox');
          }

          theme.variables.bpSmall = true;
        },
        unmatch: function() {
          theme.variables.bpSmall = false;

          if (zoomType === 'lightbox') {
            // reinit lightbox
            self.productImageGallery();
            self.selectors.$productSinglePhotos
              .find('img')
              .addClass('lightbox');
          }
        }
      });
    },

    productImageGallery: function() {
      if (!this.selectors.$productImageGallery.length) return;

      var self = this;

      this.selectors.$productImageGallery.magnificPopup({
        type: 'image',
        mainClass: 'mfp-fade',
        closeOnBgClick: true,
        closeBtnInside: false,
        closeOnContentClick: true,
        tClose: theme.strings.zoomClose,
        removalDelay: 500,
        callbacks: {
          open: function() {
            $('html').css('overflow-y', 'hidden');
          },
          close: function() {
            $('html').css('overflow-y', '');
          }
        },
        gallery: {
          enabled: true,
          navigateByImgClick: false,
          arrowMarkup:
            '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
          tPrev: theme.strings.zoomPrev,
          tNext: theme.strings.zoomNext
        }
      });

      this.selectors.$productSinglePhotos.bind('click', function() {
        var imageId = $(this).attr('data-image-id');
        self.selectors.$productImageGallery
          .filter('[data-image-id="' + imageId + '"]')
          .trigger('click');
      });
    },

    initProductImageViewer: function() {
      if (
        !this.selectors.$productImageViewer.length ||
        !this.selectors.$productSinglePhotos.length
      )
        return;

      var self = this;
      var desktopPointerQuery =
        window.matchMedia &&
        window.matchMedia(
          '(min-width: 750px) and (hover: hover) and (pointer: fine)'
        );

      var canOpenViewer = function() {
        return desktopPointerQuery && desktopPointerQuery.matches;
      };

      this.selectors.$productSinglePhotos.on(
        'click.productImageViewer keydown.productImageViewer',
        function(evt) {
          if (!canOpenViewer()) return;

          if (
            evt.type === 'keydown' &&
            evt.key !== 'Enter' &&
            evt.key !== ' '
          )
            return;

          evt.preventDefault();
          self._openProductImageViewer(
            $(this).attr('data-image-id'),
            evt.currentTarget
          );
        }
      );

      this.selectors.$productImageViewerClose.on(
        'click.productImageViewer',
        function() {
          self._closeProductImageViewer(true);
        }
      );

      this.selectors.$productImageViewerThumbnails.on(
        'click.productImageViewer',
        function(evt) {
          evt.preventDefault();
          self._scrollProductImageViewerTo(
            $(this).attr('data-image-id'),
            'smooth'
          );
        }
      );

      this.selectors.$productImageViewer.on(
        'click.productImageViewer',
        function(evt) {
          if (evt.target === this) {
            self._closeProductImageViewer(true);
          }
        }
      );

      this.selectors.$productImageViewer.on(
        'scroll.productImageViewer',
        function() {
          if (self.productImageViewerScrollFrame) return;

          self.productImageViewerScrollFrame = window.requestAnimationFrame(
            function() {
              self._updateProductImageViewerActiveThumbnail();
              self.productImageViewerScrollFrame = null;
            }
          );
        }
      );

      $(document).on(
        'keydown.productImageViewer-' + this.sectionId,
        function(evt) {
          if (
            evt.key === 'Escape' &&
            self.selectors.$productImageViewer.hasClass(
              'product-image-viewer--open'
            )
          ) {
            self._closeProductImageViewer(true);
          }
        }
      );
    },

    _openProductImageViewer: function(imageId, triggerElement) {
      var $viewer = this.selectors.$productImageViewer;

      if (!$viewer.length || $viewer.hasClass('product-image-viewer--open'))
        return;

      this.productImageViewerTrigger = triggerElement || null;

      $viewer
        .find(
          '[data-product-image-viewer-image], ' +
            '[data-product-image-viewer-thumbnail-image]'
        )
        .each(function() {
          var $image = $(this);

          if (!$image.attr('src')) {
            $image.attr('src', $image.attr('data-src'));
          }
        });

      this.selectors.$html.addClass('product-image-viewer-open');
      $('body').addClass('product-image-viewer-open');
      $viewer
        .addClass('product-image-viewer--open')
        .attr('aria-hidden', 'false')
        .scrollTop(0);

      this._scrollProductImageViewerTo(imageId, 'auto');

      this.selectors.$productImageViewerClose.focus();
    },

    _scrollProductImageViewerTo: function(imageId, behavior) {
      var $viewer = this.selectors.$productImageViewer;
      var $target = this.selectors.$productImageViewerItems
        .filter('[data-image-id="' + imageId + '"]')
        .first();

      if (!$viewer.length || !$target.length) return;

      var viewerElement = $viewer[0];
      var targetTop =
        $target[0].getBoundingClientRect().top -
        viewerElement.getBoundingClientRect().top +
        viewerElement.scrollTop;

      if (viewerElement.scrollTo) {
        viewerElement.scrollTo({
          top: targetTop,
          behavior: behavior || 'auto'
        });
      } else {
        viewerElement.scrollTop = targetTop;
      }

      this._setProductImageViewerActiveThumbnail(imageId);
    },

    _setProductImageViewerActiveThumbnail: function(imageId) {
      var $thumbnails = this.selectors.$productImageViewerThumbnails;
      var $activeThumbnail = $thumbnails
        .filter('[data-image-id="' + imageId + '"]')
        .first();

      $thumbnails
        .removeClass('is-active')
        .attr('aria-current', 'false');
      $activeThumbnail
        .addClass('is-active')
        .attr('aria-current', 'true');

      var listElement = this.selectors.$productImageViewerThumbnailList[0];
      var activeElement = $activeThumbnail[0];

      if (!listElement || !activeElement) return;

      var activeTop = activeElement.offsetTop;
      var activeBottom = activeTop + activeElement.offsetHeight;
      var visibleTop = listElement.scrollTop;
      var visibleBottom = visibleTop + listElement.clientHeight;

      if (activeTop < visibleTop) {
        listElement.scrollTop = activeTop;
      } else if (activeBottom > visibleBottom) {
        listElement.scrollTop = activeBottom - listElement.clientHeight;
      }
    },

    _updateProductImageViewerActiveThumbnail: function() {
      var $viewer = this.selectors.$productImageViewer;

      if (
        !$viewer.hasClass('product-image-viewer--open') ||
        !this.selectors.$productImageViewerItems.length
      )
        return;

      var viewerRect = $viewer[0].getBoundingClientRect();
      var viewerCenter = viewerRect.top + viewerRect.height / 2;
      var closestImageId = null;
      var closestDistance = Infinity;

      this.selectors.$productImageViewerItems.each(function() {
        var itemRect = this.getBoundingClientRect();
        var itemCenter = itemRect.top + itemRect.height / 2;
        var distance = Math.abs(itemCenter - viewerCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestImageId = $(this).attr('data-image-id');
        }
      });

      if (closestImageId) {
        this._setProductImageViewerActiveThumbnail(closestImageId);
      }
    },

    _closeProductImageViewer: function(restoreFocus) {
      var $viewer = this.selectors.$productImageViewer;

      if (!$viewer.length) return;

      $viewer
        .removeClass('product-image-viewer--open')
        .attr('aria-hidden', 'true')
        .scrollTop(0);
      this.selectors.$html.removeClass('product-image-viewer-open');
      $('body').removeClass('product-image-viewer-open');

      if (restoreFocus && this.productImageViewerTrigger) {
        $(this.productImageViewerTrigger).focus();
      }

      this.productImageViewerTrigger = null;
    },

    initThumbnails: function() {
      if (!this.selectors.$productThumbs.length) return;

      var self = this;

      // Switch the main image with one of the thumbnails
      // Note: this does not change the variant selected, just the image
      this.selectors.$productThumbs.on('click', function(evt) {
        evt.preventDefault();
        var newImageId = $(this).attr('data-image-id');
        self._switchImage(newImageId);
      });
    },

    initProductGalleryNav: function() {
      if (
        this.selectors.$productImageWrappers.length < 2 ||
        !this.selectors.$productGalleryPrev.length ||
        !this.selectors.$productGalleryNext.length
      )
        return;

      var self = this;

      this.selectors.$productGalleryPrev.on('click', function(evt) {
        evt.preventDefault();
        self._stepProductImage(-1);
      });

      this.selectors.$productGalleryNext.on('click', function(evt) {
        evt.preventDefault();
        self._stepProductImage(1);
      });

      this.selectors.$productSinglePhotos
        .find('img')
        .on('load.productGalleryNav', function() {
          self._positionProductGalleryNav();
        });

      $(window).on('resize.productGalleryNav-' + this.sectionId, function() {
        self._positionProductGalleryNav();
      });

      this._positionProductGalleryNav();
    },

    initProductGallerySwipe: function() {
      if (
        this.selectors.$productImageWrappers.length < 2 ||
        !this.selectors.$productGalleryStage.length
      )
        return;

      var self = this;
      var touchStartX = null;
      var touchStartY = null;
      var swipeThreshold = 50;

      this.selectors.$productGalleryStage
        .off('.productGallerySwipe')
        .on('touchstart.productGallerySwipe', function(evt) {
          var originalEvent = evt.originalEvent;
          var touches = originalEvent && originalEvent.touches;

          if (!theme.variables.bpSmall || !touches || touches.length !== 1) {
            touchStartX = null;
            touchStartY = null;
            return;
          }

          touchStartX = touches[0].clientX;
          touchStartY = touches[0].clientY;
        })
        .on('touchend.productGallerySwipe', function(evt) {
          var originalEvent = evt.originalEvent;
          var changedTouches = originalEvent && originalEvent.changedTouches;

          if (
            !theme.variables.bpSmall ||
            touchStartX === null ||
            touchStartY === null ||
            !changedTouches ||
            !changedTouches.length
          ) {
            touchStartX = null;
            touchStartY = null;
            return;
          }

          var deltaX = changedTouches[0].clientX - touchStartX;
          var deltaY = changedTouches[0].clientY - touchStartY;

          touchStartX = null;
          touchStartY = null;

          if (
            Math.abs(deltaX) < swipeThreshold ||
            Math.abs(deltaX) <= Math.abs(deltaY)
          )
            return;

          self._stepProductImage(deltaX < 0 ? 1 : -1);
        })
        .on('touchcancel.productGallerySwipe', function() {
          touchStartX = null;
          touchStartY = null;
        });
    },

    initProductVariant: function() {
      var self = this;
      var product = this.productSingleObject;

      var selectCallback = function(variant, selector) {
        self.productPage({
          money_format: theme.moneyFormat,
          variant: variant,
          selector: selector,
          translations: {
            add_to_cart: theme.productStrings.addToCart,
            sold_out: theme.productStrings.soldOut,
            unavailable: theme.productStrings.unavailable
          }
        });
      };

      this.optionSelector = new Shopify.OptionSelectors(
        'ProductSelect-' + this.sectionId,
        {
          product: product,
          onVariantSelected: selectCallback,
          enableHistoryState: this.enableHistoryState
        }
      );

      // Clean up variant labels if the Shopify-defined
      // defaults are the only ones left
      Slate.simplifyVariantLabels(this.productSingleObject, this.$container);
      this.initProductOptionLayout();
    },

    initProductOptionLayout: function() {
      var self = this;
      this.colorOptionIndex = null;
      this.sizeOptionIndex = null;

      $('.selector-wrapper', this.$container).each(function(index) {
        var optionName = self.productSingleObject.options[index] || '';
        var optionKey = self._getProductOptionKey(optionName);

        if (!optionKey) return;

        $(this)
          .addClass('selector-wrapper--' + optionKey)
          .children('label')
          .addClass('visually-hidden');

        if (optionKey === 'color') {
          self.colorOptionIndex = index + 1;
        }

        if (optionKey === 'size') {
          self.sizeOptionIndex = index + 1;
        }
      });

      this._buildColorOptionSwatches();
      this._buildSizeOptionButtons();
      this._moveInlineSizeCharts();

      $('.single-option-selector', this.$container).on(
        'change.productOptions',
        function() {
          window.setTimeout(function() {
            self._updateColorOptionSwatches();
            self._updateSizeOptionButtons();
          }, 0);
        }
      );

      this._updateColorOptionSwatches();
      this._updateSizeOptionButtons();
    },

    _getProductOptionKey: function(optionName) {
      optionName = optionName.toLowerCase();

      if (
        optionName.indexOf('\u30ab\u30e9\u30fc') !== -1 ||
        optionName.indexOf('\u8272') !== -1
      ) {
        return 'color';
      }

      if (optionName.indexOf('\u30b5\u30a4\u30ba') !== -1) {
        return 'size';
      }

      if (
        optionName.indexOf('color') !== -1 ||
        optionName.indexOf('colour') !== -1 ||
        optionName.indexOf('カラー') !== -1 ||
        optionName.indexOf('色') !== -1
      ) {
        return 'color';
      }

      if (
        optionName.indexOf('size') !== -1 ||
        optionName.indexOf('サイズ') !== -1
      ) {
        return 'size';
      }

      return null;
    },

    _buildColorOptionSwatches: function() {
      var self = this;
      var $colorWrapper = $('.selector-wrapper--color', this.$container).first();
      var $select = $colorWrapper.find('select').first();

      if (
        !$colorWrapper.length ||
        !$select.length ||
        $colorWrapper.find('.product-single__color-chart').length
      )
        return;

      var $chart = $('<div/>', {
        class: 'product-single__color-chart'
      });
      var $swatches = $('<div/>', {
        class: 'product-single__color-swatches',
        role: 'list'
      });
      var $selectedLabel = $('<span/>', {
        class: 'product-single__selected-color',
        'aria-live': 'polite'
      });

      $select.find('option').each(function() {
        var value = $(this).attr('value');

        if (typeof value === 'undefined') return;

        var adminSwatch = self._getAdminSwatchData(value);
        var swatchColor = adminSwatch.color || self._getSwatchColor(value);
        var $chip = $('<span/>', {
          class: 'product-single__color-chip',
          'aria-hidden': 'true'
        });

        if (adminSwatch.image) {
          $chip.css({
            'background-image': 'url(' + adminSwatch.image + ')',
            'background-position': 'center',
            'background-repeat': 'no-repeat',
            'background-size': 'cover'
          });
        } else if (swatchColor) {
          $chip.css('background-color', swatchColor);
        } else {
          $chip.addClass('is-empty');
        }

        var isSoldOut = !self.productSingleObject.variants.some(function(variant) {
          return variant.available && variant.options[self.colorOptionIndex - 1] === value;
        });

        $('<button/>', {
          type: 'button',
          class: 'product-single__color-swatch' + (isSoldOut ? ' is-sold-out' : ''),
          'data-value': value,
          'aria-label': isSoldOut ? value + ' - ' + theme.productStrings.soldOut : value,
          'aria-pressed': 'false'
        })
          .append($chip)
          .appendTo($swatches);
      });

      $select
        .addClass('product-single__native-color-select')
        .attr('aria-hidden', 'true')
        .attr('tabindex', '-1');

      $chart.on(
        'click.productOptions',
        '.product-single__color-swatch',
        function(evt) {
          evt.preventDefault();

          $select.val($(this).attr('data-value')).trigger('change');
          self._updateColorOptionSwatches();
          self._updateSizeOptionButtons();
        }
      );

      $chart.append($swatches, $selectedLabel).insertAfter($select);
      this._renderSwatchDebugPanel();
    },

    _isSwatchDebugEnabled: function() {
      return (
        window.location.search
          .replace(/^\?/, '')
          .split('&')
          .indexOf('swatch_debug=1') !== -1
      );
    },

    _initSwatchDebugPanel: function() {
      var self = this;

      if (!this._isSwatchDebugEnabled() || this.swatchDebugPanel) return;

      this.swatchDebugErrors = [];
      this.swatchDebugPanel = $('<div/>', {
        id: 'SwatchDebugPanel-' + this.sectionId,
        css: {
          position: 'fixed',
          right: '12px',
          bottom: '12px',
          zIndex: 2147483647,
          maxWidth: '520px',
          maxHeight: '50vh',
          overflow: 'auto',
          padding: '12px',
          background: '#ffffff',
          border: '1px solid #111111',
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.2)',
          color: '#111111',
          fontFamily: 'monospace',
          fontSize: '12px',
          lineHeight: '1.4',
          textAlign: 'left'
        }
      }).appendTo('body');

      if (!theme.swatchDebugErrorListenerAdded) {
        theme.swatchDebugErrorListenerAdded = true;
        window.addEventListener('error', function(evt) {
          $('.js-swatch-debug-panel').each(function() {
            var product = $(this).data('productInstance');
            if (!product || !product.swatchDebugErrors) return;

            product.swatchDebugErrors.push(
              (evt.message || 'Unknown error') +
                (evt.filename ? ' at ' + evt.filename + ':' + evt.lineno : '')
            );
            product._renderSwatchDebugPanel();
          });
        });
      }

      this.swatchDebugPanel
        .addClass('js-swatch-debug-panel')
        .data('productInstance', self);
    },

    _getRawProductSwatchesDebug: function() {
      var swatchScript = document.getElementById(
        'ProductSwatches-' + this.sectionId
      );

      if (!swatchScript) {
        return {
          exists: false,
          raw: '',
          parsed: null,
          error: ''
        };
      }

      try {
        return {
          exists: true,
          raw: swatchScript.textContent || '',
          parsed: JSON.parse(swatchScript.textContent || '{}'),
          error: ''
        };
      } catch (err) {
        return {
          exists: true,
          raw: swatchScript.textContent || '',
          parsed: null,
          error: err.message
        };
      }
    },

    _renderSwatchDebugPanel: function() {
      if (!this._isSwatchDebugEnabled()) return;

      this._initSwatchDebugPanel();

      if (!this.swatchDebugPanel) return;

      try {
        var swatchDebug = this._getRawProductSwatchesDebug();
        var options = (swatchDebug.parsed && swatchDebug.parsed.options) || [];
        var productJsonExists = !!document.getElementById(
          'ProductJson-' + this.sectionId
        );
        var colorOptionName =
          this.colorOptionIndex === null
            ? ''
            : this.productSingleObject.options[this.colorOptionIndex - 1] || '';
        var buttonRows = [];
        var self = this;

        $('.selector-wrapper--color .product-single__color-swatch', this.$container).each(
          function() {
            var $button = $(this);
            var value = $button.attr('data-value') || '';
            var adminSwatch = self._getAdminSwatchData(value);
            var fallbackColor = self._getSwatchColor(value) || '';
            var $chip = $button.find('.product-single__color-chip').first();

            buttonRows.push({
              value: value,
              adminImage: adminSwatch.image || '',
              adminColor: adminSwatch.color || '',
              fallbackColor: fallbackColor,
              finalBackgroundImage: $chip.css('background-image') || '',
              finalBackgroundColor: $chip.css('background-color') || ''
            });
          }
        );

        this.swatchDebugPanel.html(
          '<strong>Temporary swatch diagnostics</strong>' +
            '<pre style="white-space: pre-wrap; margin: 8px 0 0;">' +
            this._escapeSwatchDebugHtml(
              JSON.stringify(
                {
                  sectionId: this.sectionId,
                  productSwatchesScriptExists: swatchDebug.exists,
                  productSwatchesRaw:
                    swatchDebug.raw.length > 1000
                      ? swatchDebug.raw.slice(0, 1000) + '...'
                      : swatchDebug.raw,
                  productSwatchesJsonError: swatchDebug.error,
                  productSwatchDataError: this.productSwatchDataError || '',
                  productSwatchesOptionsLength: options.length,
                  productSwatchesOptionsHaveFields: options.map(function(option) {
                    return {
                      optionName: !!option.optionName,
                      valueName: !!option.valueName,
                      image: !!option.image,
                      color: !!option.color
                    };
                  }),
                  productJsonExists: productJsonExists,
                  getAdminSwatchDataExists:
                    typeof this._getAdminSwatchData === 'function',
                  colorOptionName: colorOptionName,
                  colorOptionIndex: this.colorOptionIndex,
                  generatedButtons: buttonRows,
                  errors: this.swatchDebugErrors || []
                },
                null,
                2
              )
            ) +
            '</pre>'
        );
      } catch (err) {
        this.swatchDebugErrors = this.swatchDebugErrors || [];
        this.swatchDebugErrors.push(err.message);
        this.swatchDebugPanel.text(
          'Temporary swatch diagnostics failed: ' + err.message
        );
      }
    },

    _escapeSwatchDebugHtml: function(value) {
      return (value || '')
        .toString()
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    },

    _getAdminSwatchData: function(colorName) {
      var swatchData = this._getProductSwatchData();
      var optionName = this.productSingleObject.options[this.colorOptionIndex - 1] || '';
      var optionKey = this._normalizeSwatchKey(optionName);
      var valueKey = this._normalizeSwatchKey(colorName);

      if (
        swatchData[optionKey] &&
        swatchData[optionKey][valueKey]
      ) {
        return swatchData[optionKey][valueKey];
      }

      return {};
    },

    _getProductSwatchData: function() {
      if (this.productSwatchData) {
        return this.productSwatchData;
      }

      var swatchData = {};
      var swatchScript = document.getElementById(
        'ProductSwatches-' + this.sectionId
      );

      if (!swatchScript) {
        this.productSwatchData = swatchData;
        return swatchData;
      }

      var parsedData;
      var options;

      try {
        parsedData = JSON.parse(swatchScript.textContent || '{}');
      } catch (err) {
        this.productSwatchData = swatchData;
        this.productSwatchDataError = err.message;
        return swatchData;
      }

      options = parsedData.options || [];

      options.forEach(function(option) {
        var optionKey = this._normalizeSwatchKey(option.optionName);
        var valueKey = this._normalizeSwatchKey(option.valueName);

        if (!optionKey || !valueKey) return;

        swatchData[optionKey] = swatchData[optionKey] || {};
        swatchData[optionKey][valueKey] = {
          image: option.image || '',
          color: option.color || ''
        };
      }, this);

      this.productSwatchData = swatchData;
      return swatchData;
    },

    _normalizeSwatchKey: function(value) {
      return (value || '')
        .toString()
        .toLowerCase()
        .replace(/[\s_-]+/g, ' ')
        .trim();
    },

    _getSwatchColor: function(colorName) {
      var normalizedColor = colorName
        .toLowerCase()
        .replace(/[\s_-]+/g, ' ')
        .trim();
      var colorMap = {
        black: '#111111',
        '\u30d6\u30e9\u30c3\u30af': '#111111',
        '\u9ed2': '#111111',
        white: '#ffffff',
        '\u30db\u30ef\u30a4\u30c8': '#ffffff',
        '\u767d': '#ffffff',
        'ice blue': '#d7e2ea',
        iceblue: '#d7e2ea',
        '\u30a2\u30a4\u30b9\u30d6\u30eb\u30fc': '#d7e2ea',
        navy: '#1b2433',
        '\u30cd\u30a4\u30d3\u30fc': '#1b2433',
        gray: '#9a9a9a',
        grey: '#9a9a9a',
        '\u30b0\u30ec\u30fc': '#9a9a9a',
        beige: '#d8c7ad',
        '\u30d9\u30fc\u30b8\u30e5': '#d8c7ad',
        brown: '#6b4a32',
        '\u30d6\u30e9\u30a6\u30f3': '#6b4a32',
        khaki: '#8a8065',
        '\u30ab\u30fc\u30ad': '#8a8065',
        pink: '#f4a7b9',
        '\u30d4\u30f3\u30af': '#f4a7b9',
        silver: '#c0c0c0',
        '\u30b7\u30eb\u30d0\u30fc': '#c0c0c0',
        gold: '#d4af37',
        '\u30b4\u30fc\u30eb\u30c9': '#d4af37',
        bronze: '#cd7f32',
        '\u30d6\u30ed\u30f3\u30ba': '#cd7f32'
      };

      return colorMap[normalizedColor];
    },

    _updateColorOptionSwatches: function() {
      var $colorWrapper = $('.selector-wrapper--color', this.$container).first();
      var $select = $colorWrapper.find('select').first();
      var selectedValue = $select.val();

      if (!$colorWrapper.length || !$select.length) return;

      $colorWrapper.find('.product-single__color-swatch').each(function() {
        var isSelected = $(this).attr('data-value') === selectedValue;

        $(this)
          .toggleClass('is-selected', isSelected)
          .attr('aria-pressed', isSelected ? 'true' : 'false');
      });

      $colorWrapper.find('.product-single__selected-color').text(selectedValue);
    },

    _buildSizeOptionButtons: function() {
      var self = this;
      var $sizeWrapper = $('.selector-wrapper--size', this.$container).first();
      var $select = $sizeWrapper.find('select').first();

      if (
        !$sizeWrapper.length ||
        !$select.length ||
        $sizeWrapper.find('.product-single__size-options').length
      )
        return;

      var $buttons = $('<div/>', {
        class: 'product-single__size-options',
        role: 'list'
      });

      $select.find('option').each(function() {
        var value = $(this).attr('value');

        if (typeof value === 'undefined') return;

        $('<button/>', {
          type: 'button',
          class: 'product-single__size-option',
          'data-value': value,
          'aria-pressed': 'false'
        })
          .text($(this).text())
          .appendTo($buttons);
      });

      $select
        .addClass('product-single__native-size-select')
        .attr('aria-hidden', 'true')
        .attr('tabindex', '-1');

      $buttons.on(
        'click.productOptions',
        '.product-single__size-option',
        function(evt) {
          evt.preventDefault();

          if ($(this).prop('disabled')) return;

          $select.val($(this).attr('data-value')).trigger('change');
          self._updateSizeOptionButtons();
        }
      );

      $buttons.insertAfter($select);
    },

    initProductSizeCharts: function() {
      var self = this;
      var $sizeOptions = $('.product-single__size-options', this.$container).first();
      var $fallbackTarget = $(
        '.product-single__cart-submit-wrapper',
        this.$container
      ).first();

      this.selectors.$productSizeCharts = $(
        '[data-product-size-chart]',
        this.$container
      );

      if (!this.selectors.$productSizeCharts.length) return;

      this.selectors.$productSizeCharts.each(function(index) {
        var $chart = $(this);
        var chartId =
          $chart.attr('id') ||
          'ProductSizeChart-' + self.sectionId + '-' + index;
        var $toggle = $('<button/>', {
          type: 'button',
          class: 'product-size-chart__toggle',
          'data-size-chart-toggle': '',
          'aria-controls': chartId,
          'aria-expanded': 'false'
        }).text('SIZE GUIDE');
        var $drawerBar = $('<div/>', {
          class: 'product-size-chart__drawer-bar',
          'data-size-chart-drawer-bar': ''
        });
        var $close = $('<button/>', {
          type: 'button',
          class: 'product-size-chart__drawer-close',
          'data-size-chart-close': '',
          'aria-controls': chartId,
          'aria-label': 'SIZE GUIDEを閉じる'
        }).text('Close');
        var $backdrop = $('<div/>', {
          class: 'product-size-chart__backdrop',
          'data-size-chart-backdrop': '',
          'data-size-chart-close': '',
          'aria-hidden': 'true',
          hidden: 'hidden'
        });

        $drawerBar.append($close).prependTo($chart);
        $backdrop.insertBefore($chart);

        $chart
          .attr('id', chartId)
          .attr('role', 'dialog')
          .attr('aria-modal', 'true')
          .attr('aria-hidden', 'true')
          .addClass('product-size-chart--drawer')
          .prop('hidden', true);

        if (!$chart.attr('aria-labelledby') && !$chart.attr('aria-label')) {
          $chart.attr('aria-label', 'SIZE GUIDE');
        }

        if ($sizeOptions.length) {
          $toggle.appendTo($sizeOptions);
        } else if ($fallbackTarget.length) {
          $toggle.insertBefore($fallbackTarget);
        } else {
          $toggle.insertBefore($backdrop);
        }
      });

      var closeDrawer = function($chart, restoreFocus) {
        if (!$chart.length) return;

        var chartId = $chart.attr('id');
        var $button = self.$container
          .find('[data-size-chart-toggle][aria-controls="' + chartId + '"]')
          .first();
        var $backdrop = $chart.prev('[data-size-chart-backdrop]');

        $button.attr('aria-expanded', 'false');
        $chart
          .removeClass('is-open')
          .attr('aria-hidden', 'true');
        $backdrop.removeClass('is-open');

        if (self.productSizeChartCloseTimer) {
          window.clearTimeout(self.productSizeChartCloseTimer);
        }

        self.productSizeChartCloseTimer = window.setTimeout(function() {
          if (!$chart.hasClass('is-open')) {
            $chart.prop('hidden', true);
            $backdrop.prop('hidden', true);
          }

          if (
            !self.selectors.$productSizeCharts.filter('.is-open').length
          ) {
            $('body').removeClass('product-size-chart-drawer-open');
          }

          self.productSizeChartCloseTimer = null;
        }, 340);

        if (
          restoreFocus &&
          self.productSizeChartTrigger &&
          $.contains(document, self.productSizeChartTrigger)
        ) {
          self.productSizeChartTrigger.focus();
        }
      };

      var openDrawer = function($button, $chart) {
        if (!$chart.length || $chart.hasClass('is-open')) return;

        self.selectors.$productSizeCharts
          .filter('.is-open')
          .each(function() {
            closeDrawer($(this), false);
          });

        if (self.productSizeChartCloseTimer) {
          window.clearTimeout(self.productSizeChartCloseTimer);
          self.productSizeChartCloseTimer = null;
        }

        var $backdrop = $chart.prev('[data-size-chart-backdrop]');

        self.productSizeChartTrigger = $button[0];
        $button.attr('aria-expanded', 'true');
        $chart
          .prop('hidden', false)
          .attr('aria-hidden', 'false')
          .scrollTop(0);
        $backdrop.prop('hidden', false);
        $('body').addClass('product-size-chart-drawer-open');

        if ($chart[0]) {
          $chart[0].offsetWidth;
        }

        $chart.addClass('is-open');
        $backdrop.addClass('is-open');
        $chart.find('[data-size-chart-close]').first().focus();
      };

      this.$container
        .off('.productSizeChart')
        .on(
          'click.productSizeChart',
          '[data-size-chart-toggle]',
          function(evt) {
            evt.preventDefault();

            var $button = $(this);
            var chartId = $button.attr('aria-controls');
            var $chart = self.selectors.$productSizeCharts
              .filter('#' + chartId)
              .first();

            if ($button.attr('aria-expanded') === 'true') {
              closeDrawer($chart, true);
            } else {
              openDrawer($button, $chart);
            }
          }
        )
        .on(
          'click.productSizeChart',
          '[data-size-chart-close]',
          function(evt) {
            evt.preventDefault();

            var $chart = $(this).closest('[data-product-size-chart]');

            if (!$chart.length) {
              $chart = $(this)
                .nextAll('[data-product-size-chart]')
                .first();
            }

            closeDrawer($chart, true);
          }
        )
        .on(
          'click.productSizeChart',
          '[data-size-chart-unit]',
          function(evt) {
            evt.preventDefault();

            var $button = $(this);
            var $chart = $button.closest('[data-product-size-chart]');
            var unit = $button.attr('data-size-chart-unit');

            self._setProductSizeChartUnit($chart, unit);
          }
        );

      $(document)
        .off('.productSizeChart-' + this.sectionId)
        .on(
          'keydown.productSizeChart-' + this.sectionId,
          function(evt) {
            var $openChart = self.selectors.$productSizeCharts
              .filter('.is-open')
              .first();

            if (!$openChart.length) return;

            if (evt.key === 'Escape') {
              evt.preventDefault();
              closeDrawer($openChart, true);
              return;
            }

            if (evt.key !== 'Tab') return;

            var $focusable = $openChart
              .find(
                'button:not(:disabled), [href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
              )
              .filter(':visible');

            if (!$focusable.length) return;

            var first = $focusable[0];
            var last = $focusable[$focusable.length - 1];

            if (evt.shiftKey && document.activeElement === first) {
              evt.preventDefault();
              last.focus();
            } else if (!evt.shiftKey && document.activeElement === last) {
              evt.preventDefault();
              first.focus();
            }
          }
        );
    },

    _setProductSizeChartUnit: function($chart, unit) {
      var showInches = unit === 'in';

      $chart
        .find('[data-size-chart-unit]')
        .removeClass('is-active')
        .attr('aria-pressed', 'false')
        .filter('[data-size-chart-unit="' + unit + '"]')
        .addClass('is-active')
        .attr('aria-pressed', 'true');

      $chart.find('[data-size-chart-value]').each(function() {
        var $cell = $(this);
        var centimeterValue = $.trim($cell.attr('data-cm-value') || '');

        if (!/^-?(?:\d+(?:\.\d+)?|\.\d+)$/.test(centimeterValue)) {
          $cell.text(centimeterValue);
          return;
        }

        $cell.text(
          showInches
            ? (parseFloat(centimeterValue) / 2.54).toFixed(1)
            : centimeterValue
        );
      });
    },

    _moveInlineSizeCharts: function() {
      var sizeChartPattern = /size\s*(chart|guide)|\u30b5\u30a4\u30ba\s*(\u30c1\u30e3\u30fc\u30c8|\u30ac\u30a4\u30c9)/i;
      var $target = $('.product-single__cart-submit-wrapper', this.$container).first();
      var $metafieldPanel = $('[data-product-size-chart]', this.$container);
      var $sizeChartContent = $();

      if (!$target.length) return;

      $('.product-single__description, .tab-switch__content', this.$container).each(function() {
        var $content = $(this);

        $content.find('h1,h2,h3,h4,h5,h6,p,strong,b,caption').each(function() {
          var $heading = $(this);
          var $headingBlock = $heading.is('strong,b')
            ? $heading.closest('p,h1,h2,h3,h4,h5,h6,caption')
            : $heading;

          if (!sizeChartPattern.test($.trim($heading.text()))) return;

          var $table = $heading.closest('table, .rte__table-wrapper');

          if (!$table.length) {
            $table = $headingBlock.nextAll('table, .rte__table-wrapper').first();
          }

          if (!$table.length) {
            $table = $headingBlock
              .parent()
              .nextAll('table, .rte__table-wrapper')
              .first();
          }

          if (!$table.length) {
            $table = $heading.closest('.rte').find('table').first();
          }

          if (!$table.length) return;

          $sizeChartContent = $sizeChartContent.add($headingBlock).add($table);
        });
      });

      if ($metafieldPanel.length) {
        $sizeChartContent.remove();
        return;
      }

      if (!$sizeChartContent.length) return;

      var $panel = $('<div/>', {
        class: 'product-single__size-chart-panel rte',
        'data-product-size-chart': '',
        'data-size-chart-source': 'legacy'
      });

      $sizeChartContent.detach().appendTo($panel);
      $panel.find('table').each(function() {
        var $table = $(this);

        if (!$table.parent().hasClass('product-single__size-chart-scroll')) {
          $table.wrap('<div class="product-single__size-chart-scroll"></div>');
        }
      });

      $target.after($panel);
    },

    _updateSizeOptionButtons: function() {
      var self = this;
      var $sizeWrapper = $('.selector-wrapper--size', this.$container).first();
      var $select = $sizeWrapper.find('select').first();
      var selectedValue = $select.val();

      if (!$sizeWrapper.length || !$select.length) return;

      $sizeWrapper.find('.product-single__size-option').each(function() {
        var $button = $(this);
        var value = $button.attr('data-value');
        var isSelected = value === selectedValue;
        var isAvailable = self._isSizeOptionAvailable(value);

        $button
          .toggleClass('is-selected', isSelected)
          .toggleClass('is-sold-out', !isAvailable)
          .prop('disabled', !isAvailable)
          .attr('aria-disabled', isAvailable ? 'false' : 'true')
          .attr('aria-pressed', isSelected ? 'true' : 'false');
      });
    },

    _isSizeOptionAvailable: function(sizeValue) {
      if (this.comingSoon) return false;
      if (!this.sizeOptionIndex) return true;

      var selectedOptions = {};

      $('.single-option-selector', this.$container).each(function(index) {
        selectedOptions[index + 1] = $(this).val();
      });

      return this.productSingleObject.variants.some(function(variant) {
        var matchesSelectedOptions = true;

        if (
          !variant.available ||
          variant['option' + this.sizeOptionIndex] !== sizeValue
        ) {
          return false;
        }

        for (var i = 1; i <= 3; i++) {
          if (
            i !== this.sizeOptionIndex &&
            selectedOptions[i] &&
            variant['option' + i] !== selectedOptions[i]
          ) {
            matchesSelectedOptions = false;
            break;
          }
        }

        return matchesSelectedOptions;
      }, this);
    },

    initProductTabs: function() {
      if (!this.selectors.$tabTrigger.length) return;

      var $trigger = this.selectors.$tabTrigger,
        $content = this.selectors.$tabContent,
        $el,
        link;

      // Hide extra content areas with JS and set active tab
      $content.filter(':gt(0)').addClass('is-hidden');
      $trigger.first().addClass('is-active');

      $trigger.on('click', function(evt) {
        evt.preventDefault();
        // set active tab
        $trigger.removeClass('is-active');
        $el = $(this).addClass('is-active');

        // hide all content areas, then show desired one
        link = $el.data('link');
        $content.addClass('is-hidden');
        $content
          .filter('[data-content="' + link + '"]')
          .removeClass('is-hidden');
      });
    },

    productPage: function(options) {
      var self = this;
      var variant = options.variant;

      if (variant) {
        // Update variant image, if one is set
        if (variant.featured_image) {
          var newImg = variant.featured_image;
          self._switchImage(newImg.id);
        }

        // Update the product price
        this.selectors.$productPrice.html(
          Shopify.formatMoney(variant.price, theme.moneyFormat)
        );

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          this.selectors.$comparePrice
            .html(
              Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat)
            )
            .removeClass('hide');
          this.selectors.$productPrice.addClass(
            'product-single__price--on-sale'
          );
          this.selectors.$comparePriceA11y.attr('aria-hidden', 'false');
          this.selectors.$priceA11y.attr('aria-hidden', 'false');
        } else {
          this.selectors.$comparePrice.addClass('hide');
          this.selectors.$productPrice.removeClass(
            'product-single__price--on-sale'
          );
          this.selectors.$comparePriceA11y.attr('aria-hidden', 'true');
        }

        // Update the full details link
        var $link = this.selectors.$productFullDetails;
        if ($link.length) {
          $link.attr(
            'href',
            this.updateUrlParameter($link.attr('href'), 'variant', variant.id)
          );
        }

        // Select a valid variant if available
        if (this.comingSoon) {
          // Product metafield takes priority over every variant's inventory state.
          this.selectors.$addToCartBtn
            .prop('disabled', true)
            .attr('aria-disabled', 'true');
          this.selectors.$addToCartText.text(this.comingSoonText);
          this.selectors.$shopifyPaymentButton.hide();
        } else if (variant.available) {
          // We have a valid product variant, so enable the submit button
          this.selectors.$addToCartBtn.prop('disabled', false);
          this.selectors.$addToCartText.html(theme.strings.addToCart);
          this.selectors.$shopifyPaymentButton.show();
        } else {
          // Variant is sold out, disable the submit button and change the text
          this.selectors.$addToCartBtn.prop('disabled', true);
          this.selectors.$addToCartText.html(theme.strings.soldOut);
          this.selectors.$shopifyPaymentButton.hide();
        }
        // Show SKU
        this.selectors.$SKU.html(variant.sku);

        // Unit price
        this.selectors.$unitPriceContainer.removeClass(
          'product-unit-price--available'
        );

        if (variant.unit_price_measurement) {
          this.selectors.$unitPrice.html(
            Shopify.formatMoney(variant.unit_price, theme.moneyFormat)
          );
          this.selectors.$unitPriceBaseUnit.html(this._getBaseUnit(variant));
          this.selectors.$unitPriceContainer.addClass(
            'product-unit-price--available'
          );
        }
      } else {
        // The variant doesn't exist, disable submit button and change the text.
        // This may be an error or notice that a specific variant is not available.
        this.selectors.$addToCartBtn.prop('disabled', true);
        this.selectors.$addToCartText.html(
          this.comingSoon ? this.comingSoonText : theme.strings.unavailable
        );
        this.selectors.$shopifyPaymentButton.hide();
      }
    },

    updateUrlParameter: function(url, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      var separator = url.indexOf('?') === -1 ? '?' : '&';

      if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        return url + separator + key + '=' + value;
      }
    },

    enableAjax: function() {
      var self = this;

      this.selectors.$addToCartBtn.on('click', function(evt) {
        evt.preventDefault();

        if (self.comingSoon) return;

        $('.errors').remove();
        var $addToCartBtn = $(this),
          $addToCartForm = $(this).closest('form'),
          $addToCartText = $(this).find('span');
        if ($addToCartForm.length) {
          $addToCartBtn
            .data('add-to-cart', $addToCartText.text())
            .prop('disabled', true)
            .addClass('btn--ajax-disabled');
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: $addToCartForm.serialize(),
            success: function() {
              var drawerRequest = null;
              var hasCartDrawer =
                theme.cartDrawer && theme.cartDrawer.isAvailable;

              if (hasCartDrawer) {
                drawerRequest = theme.cartDrawer.refresh(true);

                if (drawerRequest) {
                  drawerRequest.fail(function() {
                    theme.afterCartLoad();
                  });
                }
              } else {
                theme.afterCartLoad();
              }

              $addToCartBtn.prop('disabled', false);
              $addToCartBtn.removeClass('btn--ajax-disabled');

              if (!hasCartDrawer) {
                addToCartflip($addToCartBtn);
              }
            },
            error: function(XMLHttpRequest) {
              var data = eval('(' + XMLHttpRequest.responseText + ')');
              var response = data.description;
              var status = XMLHttpRequest.status;
              $addToCartBtn.removeClass('btn--ajax-disabled');
              if (status === 422) {
                $addToCartText.text(theme.strings.soldOut);
              } else {
                $addToCartBtn.prop('disabled', false);
                $addToCartText.text($addToCartBtn.data('add-to-cart'));
              }
              $addToCartBtn.after('<p class="errors">' + response + '</p>');
            }
          });
        }
      });
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.$productImageWrappers.selector +
          "[data-image-id='" +
          imageId +
          "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.$productImageWrappers.selector +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass('hidden');
      $otherImages.addClass('hidden');
      this._positionProductGalleryNav();
    },

    _stepProductImage: function(direction) {
      var $images = this.selectors.$productImageWrappers;
      var currentIndex = $images.index($images.not('.hidden').first());

      if (currentIndex < 0) {
        currentIndex = 0;
      }

      var nextIndex =
        (currentIndex + direction + $images.length) % $images.length;
      this._switchImage($images.eq(nextIndex).attr('data-image-id'));
    },

    _positionProductGalleryNav: function() {
      if (
        !this.selectors.$productGalleryStage.length ||
        !this.selectors.$productGalleryPrev.length ||
        !this.selectors.$productGalleryNext.length
      )
        return;

      if (theme.variables.bpSmall) {
        this.selectors.$productGalleryPrev.css({
          left: '',
          right: ''
        });

        this.selectors.$productGalleryNext.css({
          left: '',
          right: ''
        });

        return;
      }

      this.selectors.$productGalleryPrev.css({
        left: '',
        right: 'auto'
      });

      this.selectors.$productGalleryNext.css({
        right: '0px',
        left: 'auto'
      });
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  });

  function addToCartflip($addToCartBtn) {
    var cartUrl = $addToCartBtn.data('cart-url');

    $addToCartBtn.addClass('btn--unflipped').hide();

    $('<div></div>')
      .text(theme.strings.itemAddedToCart)
      .addClass('product-single__notification')
      .insertAfter($addToCartBtn);

    $('<button></button>')
      .text(theme.strings.viewCart)
      .addClass('btn btn--view-cart btn--secondary')
      .click(function(evt) {
        evt.preventDefault();
        window.location.href = cartUrl;
      })
      .insertAfter($addToCartBtn);

    $('.single-option-selector, [name="quantity"]').bind('click', function() {
      $(this)
        .closest('form')
        .find('.btn--view-cart, .product-single__notification, .errors')
        .remove();
      $(this)
        .closest('form')
        .find('.btn--unflipped')
        .removeClass('.btn--unflipped')
        .show();
    });
  }

  return Product;
})();

window.theme = window.theme || {};

theme.Collection = (function() {
  function Collection(container) {
    var $container = (this.$container = $(container));
    this.sortEnabled = $container.data('sort-enabled');
    this.tagsEnabled = $container.data('tags-enabled');

    this.init();
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    init: function() {
      this.stringOverrides();

      if (this.sortEnabled) {
        this.collectionSorting();
      }

      if (this.tagsEnabled) {
        this.collectionTags();
      }

      this.initProductCardSwipe();
    },

    onUnload: function() {
      this.$container.off('.productCardSwipe');
    },

    initProductCardSwipe: function() {
      if (!this.$container.find('[data-product-card-image]').length) return;

      var swipeThreshold = 50;

      var getImageCount = function($imageLink) {
        return (
          parseInt(
            $imageLink.attr('data-product-card-image-count'),
            10
          ) || 0
        );
      };

      var getImage = function($imageLink, imageIndex) {
        return $imageLink
          .find(
            '[data-product-card-image][data-product-card-image-index="' +
              imageIndex +
              '"]'
          )
          .first();
      };

      var activateImage = function($imageLink, $image, imageIndex) {
        $imageLink
          .find('[data-product-card-image]')
          .removeClass('product__image--active')
          .attr('aria-hidden', 'true');

        $image
          .addClass('product__image--active')
          .attr('aria-hidden', 'false');

        $imageLink
          .data('productCardImageIndex', imageIndex)
          .removeData('productCardPendingImageIndex');

        var $colorSwatches = $imageLink
          .closest('.product')
          .find('[data-product-card-color-swatch]');

        $colorSwatches
          .removeClass('is-selected')
          .attr('aria-pressed', 'false')
          .filter(
            '[data-product-card-image-index="' + imageIndex + '"]'
          )
          .addClass('is-selected')
          .attr('aria-pressed', 'true');
      };

      var showImage = function($imageLink, imageIndex) {
        var $image = getImage($imageLink, imageIndex);

        if (!$image.length) return false;

        if ($image.hasClass('lazyloaded')) {
          activateImage($imageLink, $image, imageIndex);
          return true;
        }

        $imageLink.data('productCardPendingImageIndex', imageIndex);

        if ($image.is('[data-product-card-deferred-image]')) {
          $image
            .removeAttr('data-product-card-deferred-image')
            .addClass('lazyload');
        }

        if (
          $image.hasClass('lazyload') &&
          window.lazySizes &&
          window.lazySizes.loader &&
          window.lazySizes.loader.unveil
        ) {
          window.lazySizes.loader.unveil($image.get(0));
        }

        return true;
      };

      var getCurrentImageIndex = function($imageLink) {
        var currentIndex = parseInt(
          $imageLink.data('productCardPendingImageIndex'),
          10
        );

        if (isNaN(currentIndex)) {
          currentIndex = parseInt(
            $imageLink.data('productCardImageIndex'),
            10
          );
        }

        if (isNaN(currentIndex)) {
          currentIndex =
            parseInt(
              $imageLink
                .find('.product__image--active')
                .attr('data-product-card-image-index'),
              10
            ) || 0;
        }

        return currentIndex;
      };

      var stepImage = function($imageLink, direction) {
        var imageCount = getImageCount($imageLink);

        if (imageCount < 2) return false;

        var nextIndex =
          (getCurrentImageIndex($imageLink) + direction + imageCount) %
          imageCount;

        return showImage($imageLink, nextIndex);
      };

      this.$container
        .off('.productCardSwipe')
        .on(
          'lazyloaded.productCardSwipe',
          '[data-product-card-image]',
          function() {
            var $image = $(this);
            var $imageLink = $image.closest('[data-image-link]');
            var imageIndex = parseInt(
              $image.attr('data-product-card-image-index'),
              10
            );
            var pendingIndex = parseInt(
              $imageLink.data('productCardPendingImageIndex'),
              10
            );

            if (imageIndex !== pendingIndex) return;

            activateImage($imageLink, $image, imageIndex);
          }
        )
        .on(
          'click.productCardSwipe',
          '[data-product-card-gallery-prev], [data-product-card-gallery-next]',
          function(evt) {
            evt.preventDefault();
            evt.stopPropagation();

            var $button = $(this);
            var $imageLink = $button
              .closest('.product-card__gallery')
              .find('[data-image-link]')
              .first();
            var direction = $button.is('[data-product-card-gallery-prev]')
              ? -1
              : 1;

            if (!$imageLink.length) return;

            stepImage($imageLink, direction);
          }
        )
        .on(
          'click.productCardSwipe',
          '[data-product-card-color-swatch]',
          function(evt) {
            evt.preventDefault();
            evt.stopPropagation();

            var $swatch = $(this);
            var imageIndex = parseInt(
              $swatch.attr('data-product-card-image-index'),
              10
            );
            var $imageLink = $swatch
              .closest('.product')
              .find('[data-image-link]')
              .first();

            if (isNaN(imageIndex) || !$imageLink.length) return;

            $imageLink.addClass(
              'product__image-wrapper--color-selected'
            );
            showImage($imageLink, imageIndex);
          }
        )
        .on('touchstart.productCardSwipe', '[data-image-link]', function(evt) {
          var $imageLink = $(this);
          var originalEvent = evt.originalEvent;
          var touches = originalEvent && originalEvent.touches;

          if (
            !theme.variables.bpSmall ||
            getImageCount($imageLink) < 2 ||
            !touches ||
            touches.length !== 1
          ) {
            $imageLink.removeData('productCardSwipeStart');
            return;
          }

          $imageLink.data('productCardSwipeStart', {
            x: touches[0].clientX,
            y: touches[0].clientY
          });
        })
        .on('touchend.productCardSwipe', '[data-image-link]', function(evt) {
          var $imageLink = $(this);
          var touchStart = $imageLink.data('productCardSwipeStart');
          var originalEvent = evt.originalEvent;
          var changedTouches = originalEvent && originalEvent.changedTouches;

          $imageLink.removeData('productCardSwipeStart');

          if (
            !theme.variables.bpSmall ||
            !touchStart ||
            !changedTouches ||
            !changedTouches.length
          )
            return;

          var deltaX = changedTouches[0].clientX - touchStart.x;
          var deltaY = changedTouches[0].clientY - touchStart.y;

          if (
            Math.abs(deltaX) < swipeThreshold ||
            Math.abs(deltaX) <= Math.abs(deltaY)
          )
            return;

          var direction = deltaX < 0 ? 1 : -1;

          if (!stepImage($imageLink, direction)) return;

          $imageLink.data(
            'productCardSwipeBlockClickUntil',
            Date.now() + 500
          );
        })
        .on('touchcancel.productCardSwipe', '[data-image-link]', function() {
          $(this).removeData('productCardSwipeStart');
        })
        .on('click.productCardSwipe', '[data-image-link]', function(evt) {
          var $imageLink = $(this);
          var blockClickUntil =
            $imageLink.data('productCardSwipeBlockClickUntil') || 0;

          if (Date.now() > blockClickUntil) return;

          evt.preventDefault();
          $imageLink.removeData('productCardSwipeBlockClickUntil');
        });
    },

    stringOverrides: function() {
      // Override defaults in theme.strings with potential
      // template overrides

      theme.collectionStrings = theme.collectionStrings || {};
      $.extend(theme.strings, theme.collectionStrings);
    },

    collectionSorting: function() {
      /*=============================================================================
        Initialised here because collection liquid object is only available
        on collection pages, and not external JS files
      ==============================================================================*/
      Shopify.queryParams = {};
      if (location.search.length && location.search.indexOf('sort_by')) {
        for (
          var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
          i < aCouples.length;
          i++
        ) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      $(function() {
        $('#SortBy')
          .val(theme.strings.sortBy)
          .bind('change', function() {
            Shopify.queryParams.sort_by = jQuery(this).val();
            if (Shopify.queryParams.page) {
              delete Shopify.queryParams.page;
            }
            location.search = decodeURIComponent(
              jQuery.param(Shopify.queryParams)
            );
          });
      });
    },

    collectionTags: function() {
      var $browseBy = $('#BrowseBy');
      $(function() {
        $browseBy.bind('change', function() {
          location.href = $browseBy.val();
        });
      });
    }
  });

  return Collection;
})();

window.theme = window.theme || {};

theme.FooterSection = (function() {
  function Footer(container) {
    this.$container = $(container);
    this.$modal = this.$container.find('[data-localization-modal]');
    this.$panel = this.$modal.find('[data-localization-modal-panel]');
    this.$triggers = this.$container.find('[data-localization-modal-open]');
    this.lastFocusedElement = null;

    theme.styleTextLinks();
    this.initLocalizationModal();
  }

  Footer.prototype = {
    initLocalizationModal: function() {
      var self = this;

      if (!this.$modal.length || !this.$triggers.length) {
        return;
      }

      this.$triggers
        .off('click.localizationModal')
        .on('click.localizationModal', function(evt) {
          evt.preventDefault();
          self.openLocalizationModal(this);
        });

      this.$modal
        .off('click.localizationModal')
        .on(
          'click.localizationModal',
          '[data-localization-modal-close]',
          function(evt) {
            evt.preventDefault();
            self.closeLocalizationModal();
          }
        );

      $(document)
        .off('keydown.localizationModal')
        .on('keydown.localizationModal', function(evt) {
          self.handleLocalizationKeydown(evt);
        });
    },

    openLocalizationModal: function(trigger) {
      var target = $(trigger).attr('data-localization-modal-open');
      var $targetHeading = this.$modal.find(
        '[data-localization-heading="' + target + '"]'
      );

      this.lastFocusedElement = trigger;
      this.$panel.scrollTop(0);

      if ($targetHeading.length) {
        this.$panel.attr('aria-labelledby', $targetHeading.first().attr('id'));
      }

      this.$modal.attr('aria-hidden', 'false');
      this.$triggers.attr('aria-expanded', 'true');
      $('body').addClass('localization-modal-open');

      window.setTimeout(
        function() {
          if ($targetHeading.length) {
            $targetHeading.first().focus();
          } else {
            this.$panel.focus();
          }
        }.bind(this),
        0
      );
    },

    closeLocalizationModal: function() {
      if (!this.$modal.length) {
        return;
      }

      this.$modal.attr('aria-hidden', 'true');
      this.$triggers.attr('aria-expanded', 'false');
      $('body').removeClass('localization-modal-open');

      if (this.lastFocusedElement) {
        $(this.lastFocusedElement).focus();
      }
    },

    handleLocalizationKeydown: function(evt) {
      var $focusable;
      var firstElement;
      var lastElement;

      if (!this.$modal.length || this.$modal.attr('aria-hidden') !== 'false') {
        return;
      }

      if (evt.key === 'Escape' || evt.which === 27) {
        evt.preventDefault();
        this.closeLocalizationModal();
        return;
      }

      if (evt.key !== 'Tab' && evt.which !== 9) {
        return;
      }

      $focusable = this.$modal
        .find(
          'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
        .filter(':visible');

      if (!$focusable.length) {
        evt.preventDefault();
        this.$panel.focus();
        return;
      }

      firstElement = $focusable.get(0);
      lastElement = $focusable.get($focusable.length - 1);

      if (evt.shiftKey && document.activeElement === firstElement) {
        evt.preventDefault();
        lastElement.focus();
      } else if (!evt.shiftKey && document.activeElement === lastElement) {
        evt.preventDefault();
        firstElement.focus();
      }
    },

    onUnload: function() {
      this.closeLocalizationModal();
      this.$triggers.off('.localizationModal');
      this.$modal.off('.localizationModal');
      $(document).off('keydown.localizationModal');
    }
  };

  return Footer;
})();

window.theme = window.theme || {};

theme.FeaturedContentSection = (function() {
  function FeaturedContent() {
    theme.styleTextLinks();
  }

  return FeaturedContent;
})();

window.theme = window.theme || {};

theme.NewsletterSection = (function() {
  function Newsletter() {
    theme.styleTextLinks();
  }

  return Newsletter;
})();

window.theme = window.theme || {};

var classes = {
  navCollapse: 'site-nav__collapse',
  navExpand: 'site-nav__expand',
  activeSubmenu: 'site-nav__submenu--active',
  collapsedSubmenus: 'site-nav__submenu--collapsed',
  expandedSubmenus: 'site-nav__submenu--expanded'
};

var selectors = {
  submenu: '.site-nav__submenu',
  collapsedSubmenus: '.site-nav__submenu--collapsed',
  expandedSubmenus: '.site-nav__submenu--expanded',
  submenuTrigger: '.site-nav__link',
  submenuTriggerText: '.site-nav__link__text',
  submenuParent: '.site-nav--has-submenu',
  activeSubmenuParent: '.site-nav--active',
  activeSubmenu: '.site-nav__submenu--active',
  mobileMenuTrigger: '#ToggleMobileMenu',
  siteNav: '#SiteNav'
};

theme.SidebarSection = (function() {
  function Sidebar() {
    this.init();

    $(selectors.siteNav)
      .removeClass('site-nav--open')
      .attr('aria-hidden', 'true');

    $(selectors.mobileMenuTrigger)
      .off('click.sidebarMenu')
      .on(
        'click.sidebarMenu',
        function(evt) {
          var $mobileMenu = $(evt.target).closest(selectors.mobileMenuTrigger);
          var shouldOpen = !$mobileMenu.hasClass('open');

          evt.preventDefault();
          $mobileMenu
            .toggleClass('open', shouldOpen)
            .attr('aria-expanded', shouldOpen ? 'true' : 'false');

          $(selectors.siteNav)
            .toggleClass('site-nav--open', shouldOpen)
            .attr('aria-hidden', shouldOpen ? 'false' : 'true');

          // Hide submenus on menu toggle
          $(selectors.submenuParent)
            .has(selectors.expandedSubmenus)
            .hideSubmenu(0);
        }.bind(this)
      );
  }

  Sidebar.prototype = _.assignIn({}, Sidebar.prototype, {
    init: function() {
      $(selectors.submenuTrigger).on('click', function() {
        var $trigger = $(this);
        var $parent = $trigger.parent(selectors.submenuParent);
        var shouldExpand = $trigger.hasClass(classes.navExpand);

        if (shouldExpand) {
          // Remove active class from all submenus
          $(selectors.activeSubmenu).removeClass(classes.activeSubmenu);

          // Show submenus with active elements
          $parent
            .find(selectors.collapsedSubmenus)
            .has(selectors.activeSubmenuParent)
            .parent(selectors.submenuParent)
            .not($parent)
            .showSubmenu(0);

          $parent.showSubmenu(400);

          // Hide all other menus on the same level
          $parent
            .siblings(selectors.submenuParent)
            .has(selectors.expandedSubmenus)
            .hideSubmenu(400);
        } else {
          $parent.hideSubmenu(400);
        }
      });
    }
  });

  $.fn.showSubmenu = function(duration) {
    // Toggle button
    this.children(selectors.submenuTrigger)
      .removeClass(classes.navExpand)
      .addClass(classes.navCollapse)
      .attr('aria-expanded', true)
      .children(selectors.submenuTriggerText)
      .text('-');

    // Show menu
    this.children(selectors.submenu)
      .addClass(classes.activeSubmenu)
      .addClass(classes.expandedSubmenus)
      .removeClass(classes.collapsedSubmenus)
      .slideDown(duration)
      .attr('aria-hidden', false);

    return this;
  };

  $.fn.hideSubmenu = function(duration) {
    // Toggle button
    this.children(selectors.submenuTrigger)
      .removeClass(classes.navCollapse)
      .addClass(classes.navExpand)
      .attr('aria-expanded', false)
      .children(selectors.submenuTriggerText)
      .text('+');

    // Hide submenu
    this.children(selectors.submenu)
      .addClass(classes.collapsedSubmenus)
      .removeClass(classes.expandedSubmenus)
      .slideUp(duration, function() {
        // Hide all child submenus
        $(this)
          .find(selectors.expandedSubmenus)
          .not(this)
          .parent(selectors.submenuParent)
          .hideSubmenu(0);
      })
      .attr('aria-hidden', true);

    return this;
  };

  return Sidebar;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    this.$container = $(container);
    var id = this.$container.attr('data-section-id');
    var slideshow = (this.slideshow = '#flexslider--' + id);

    theme.slideshows[slideshow] = new theme.Hero(slideshow, id);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var $slide = $(
        '#slide--' + evt.originalEvent.detail.blockId + ':not(.clone)'
      );
      var slideIndex = $slide.data('flexslider-index');
      var $slideImg = $slide.find('img');
      $slideshow.flexslider(slideIndex, true);
      $slideshow.flexslider('pause');

      $slideImg.on('load', this.resizeOnImageLoad($slideImg)).bind(this);
    },

    onSelect: function() {
      var $slideshow = $(this.slideshow);
      var $slideImg = $slideshow.find('img').first();

      $slideImg.on('load', this.resizeOnImageLoad($slideImg)).bind(this);
    },

    onBlockDeselect: function() {
      var $slideshow = $(this.slideshow);
      // Check if we need to resume autoplay
      if (
        $slideshow.data('autoplay') &&
        !$slideshow
          .parent()
          .find('[data-slider-pause]')
          .hasClass('is-paused')
      ) {
        $slideshow.flexslider('play');
      }
    },

    resizeOnImageLoad: function($slideImg) {
      var intervalAttempts = 0;
      var $slideshow = $(this.slideshow);

      // Needed to resize the slider as the on('load') listener doesn't wait until the image has loaded.
      var imageHeightCheck = setInterval(function() {
        intervalAttempts++;
        if (
          $slideImg.length &&
          $slideImg.height() === 0 &&
          intervalAttempts < 10
        ) {
          sizeSlideshow($slideshow);
        } else {
          // clear interval
          sizeSlideshow($slideshow);
          clearInterval(imageHeightCheck);
        }
      }, 500);

      function sizeSlideshow($slideshow) {
        $slideshow.resize();
      }
    }
  }
);

window.theme = window.theme || {};

theme.PasswordContent = (function() {
  function PasswordContent() {
    this.init();
  }

  PasswordContent.prototype = _.assignIn({}, PasswordContent.prototype, {
    init: function() {
      theme.styleTextLinks();

      $('.password-login-toggle').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
        closeOnBgClick: false,
        closeBtnInside: false,
        closeOnContentClick: false,
        tClose: "閉じる (Esc)",
        removalDelay: 500,
        callbacks: {
          open: function() {
            window.setTimeout( function() { document.getElementById('Password').focus(); }, 50 );
          },
          close: function() {
            window.setTimeout( function() { document.getElementById('Email').focus(); }, 50 );
          }
        }
      });
      if ( $('.storefront-password-form .errors').size() ) {
        $('.password-login-toggle').click();
      }
    }
  });

  return PasswordContent;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.mapStrings.addressNoResults,
    addressQueryLimit: theme.mapStrings.addressQueryLimit,
    addressError: theme.mapStrings.addressError,
    authError: theme.mapStrings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) return;

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.mapStrings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') return;

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + this.key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + this.key
        ).then(function() {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            // eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(window, 'resize', function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              $map.removeAttr('style');
            });
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) return;

      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    this.$container = $(container);

    var self = this;
    var baseUrl = this.$container.data('baseUrl');
    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4&intent=related';

    $.get(recommendationsSectionUrl).then(function(section) {
      var recommendationsMarkup = $(section).html();
      if (recommendationsMarkup.trim() !== '') {
        self.$container.html(recommendationsMarkup);
      }
    });
  }

  return ProductRecommendations;
})();


// Add theme-related JS after _slate.js.liquid

theme.CartDrawer = (function() {
  function CartDrawer() {
    this.$drawer = $('[data-cart-drawer]').first();
    this.isAvailable = this.$drawer.length > 0;

    if (!this.isAvailable) {
      return;
    }

    this.$panel = this.$drawer.find('[data-cart-drawer-panel]');
    this.$close = this.$drawer.find('.cart-drawer__close');
    this.$trigger = $('[data-cart-drawer-trigger]');
    this.$count = this.$drawer.find('[data-cart-drawer-count]');
    this.$items = this.$drawer.find('[data-cart-drawer-items]');
    this.$footer = this.$drawer.find('[data-cart-drawer-footer]');
    this.$subtotal = this.$drawer.find('[data-cart-drawer-subtotal]');
    this.$error = this.$drawer.find('[data-cart-drawer-error]');
    this.$tabs = this.$drawer.find('[data-cart-drawer-tab]');
    this.$views = this.$drawer.find('[data-cart-drawer-view]');
    this.currentView = 'bag';
    this.cartJsonUrl = this.$drawer.attr('data-cart-json-url') || '/cart.js';
    this.cartChangeUrl =
      this.$drawer.attr('data-cart-change-url') || '/cart/change.js';
    this.cartUrl = this.$drawer.attr('data-cart-url') || '/cart';
    this.moneyFormat =
      this.$drawer.attr('data-money-format') || theme.moneyFormat;
    this.currency = (
      this.$drawer.attr('data-currency') || 'JPY'
    ).toUpperCase();
    this.lastFocusedElement = null;

    this._bindEvents();
  }

  CartDrawer.prototype = {
    _bindEvents: function() {
      var self = this;

      this.$drawer.on(
        'click.cartDrawer',
        '[data-cart-drawer-close]',
        function(evt) {
          evt.preventDefault();
          self.close();
        }
      );

      this.$drawer.on(
        'click.cartDrawer',
        '[data-cart-drawer-remove]',
        function(evt) {
          evt.preventDefault();
          self._removeItem($(this));
        }
      );

      this.$drawer.on(
        'click.cartDrawer',
        '[data-cart-drawer-tab]',
        function(evt) {
          var view = $(this).attr('data-cart-drawer-tab');

          evt.preventDefault();
          self.showView(view);

          if (view === 'bag') {
            self.refresh(false);
          }
        }
      );

      this.$trigger
        .off('click.cartDrawer')
        .on('click.cartDrawer', function(evt) {
          var cartUrl = $(this).attr('href') || self.cartUrl;
          var request;

          if (
            (evt.which && evt.which !== 1) ||
            evt.metaKey ||
            evt.ctrlKey ||
            evt.shiftKey ||
            evt.altKey
          ) {
            return;
          }

          evt.preventDefault();
          request = self.refresh(true);

          if (request) {
            request.fail(function() {
              window.location.href = cartUrl;
            });
          }
        });

      $(document).on('keydown.cartDrawer', function(evt) {
        self._handleKeydown(evt);
      });
    },

    refresh: function(openAfterLoad) {
      var self = this;
      var request;

      if (!this.isAvailable) {
        return null;
      }

      if (openAfterLoad) {
        this.open('bag');
      }

      this.$drawer.attr('aria-busy', 'true');
      this.$error.prop('hidden', true).text('');

      request = $.getJSON(this.cartJsonUrl);

      request
        .done(function(cart) {
          self.render(cart);
        })
        .fail(function() {
          self._showError('Unable to load your bag. Please view the bag page.');
        })
        .always(function() {
          self.$drawer.attr('aria-busy', 'false');
        });

      return request;
    },

    render: function(cart) {
      var itemCount = parseInt(cart.item_count, 10) || 0;
      var itemsHtml = '';
      var self = this;

      if (cart && cart.currency) {
        this.currency = String(cart.currency).toUpperCase();
      }

      this.$count.text(itemCount);
      this._updateHeaderCount(itemCount);

      if (itemCount === 0) {
        itemsHtml = '<p class="cart-drawer__empty">Your bag is empty.</p>';
      } else {
        $.each(cart.items || [], function(index, item) {
          itemsHtml += self._renderItem(item);
        });
      }

      this.$items.html(itemsHtml);
      this.$subtotal.html(this._formatMoney(cart.total_price || 0));
      this.$footer.prop('hidden', itemCount === 0);
    },

    showView: function(view) {
      var selectedView = view === 'saved' ? 'saved' : 'bag';

      this.currentView = selectedView;

      this.$tabs.each(function() {
        var $tab = $(this);
        var isActive =
          $tab.attr('data-cart-drawer-tab') === selectedView;

        $tab
          .toggleClass('is-active', isActive)
          .attr('aria-selected', isActive ? 'true' : 'false')
          .attr('tabindex', isActive ? '0' : '-1');
      });

      this.$views.each(function() {
        var $view = $(this);
        var isActive =
          $view.attr('data-cart-drawer-view') === selectedView;

        $view.prop('hidden', !isActive);
      });

      if (selectedView === 'saved') {
        document.dispatchEvent(
          new CustomEvent('soshiotsuki:saved-view-open')
        );
      }
    },

    open: function(view) {
      if (!this.isAvailable) {
        return;
      }

      if (view) {
        this.showView(view);
      }

      if (this.$drawer.hasClass('cart-drawer--open')) {
        return;
      }

      this.lastFocusedElement = document.activeElement;
      this.$drawer
        .addClass('cart-drawer--open')
        .attr('aria-hidden', 'false');
      this.$trigger.attr('aria-expanded', 'true');
      $('body').addClass('cart-drawer-open');

      var self = this;
      window.setTimeout(function() {
        self.$close.focus();
      }, 40);
    },

    close: function() {
      if (!this.isAvailable || !this.$drawer.hasClass('cart-drawer--open')) {
        return;
      }

      this.$drawer
        .removeClass('cart-drawer--open')
        .attr('aria-hidden', 'true');
      this.$trigger.attr('aria-expanded', 'false');
      $('body').removeClass('cart-drawer-open');

      if (
        this.lastFocusedElement &&
        $.contains(document, this.lastFocusedElement)
      ) {
        $(this.lastFocusedElement).focus();
      }

      this.lastFocusedElement = null;
    },

    _renderItem: function(item) {
      var productTitle = item.product_title || item.title || '';
      var productUrl = item.url || this.cartUrl;
      var imageUrl =
        item.image ||
        (item.featured_image && item.featured_image.url) ||
        '';
      var linePrice =
        item.final_line_price != null
          ? item.final_line_price
          : item.line_price || 0;
      var imageHtml = '';

      if (imageUrl) {
        imageHtml =
          '<img class="cart-drawer__item-image" src="' +
          this._escapeHtml(imageUrl) +
          '" alt="' +
          this._escapeHtml(productTitle) +
          '" loading="lazy">';
      }

      return (
        '<article class="cart-drawer__item">' +
          '<a class="cart-drawer__item-image-link" href="' +
            this._escapeHtml(productUrl) +
            '">' +
            imageHtml +
          '</a>' +
          '<div class="cart-drawer__item-info">' +
            '<div>' +
              '<a class="cart-drawer__item-title" href="' +
                this._escapeHtml(productUrl) +
                '">' +
                this._escapeHtml(productTitle) +
              '</a>' +
              '<p class="cart-drawer__item-price">' +
                this._formatMoney(linePrice) +
              '</p>' +
            '</div>' +
            '<div class="cart-drawer__item-options">' +
              this._renderOptions(item) +
              '<p>Qty: ' + (parseInt(item.quantity, 10) || 0) + '</p>' +
            '</div>' +
            '<button type="button" class="cart-drawer__remove" ' +
              'data-cart-drawer-remove="' +
              this._escapeHtml(item.key) +
              '" aria-label="' +
              this._escapeHtml(productTitle) +
              'をカートから削除">削除</button>' +
          '</div>' +
        '</article>'
      );
    },

    _renderOptions: function(item) {
      var self = this;
      var html = '';

      $.each(item.options_with_values || [], function(index, option) {
        if (!option || !option.value || option.value === 'Default Title') {
          return;
        }

        html +=
          '<p>' +
          self._escapeHtml(option.name) +
          ': ' +
          self._escapeHtml(option.value) +
          '</p>';
      });

      $.each(item.properties || {}, function(name, value) {
        if (!value || String(name).charAt(0) === '_') {
          return;
        }

        html +=
          '<p>' +
          self._escapeHtml(name) +
          ': ' +
          self._escapeHtml(value) +
          '</p>';
      });

      return html;
    },

    _removeItem: function($button) {
      var self = this;
      var itemKey = $button.attr('data-cart-drawer-remove');

      if (!itemKey) {
        return;
      }

      $button.prop('disabled', true);
      this.$drawer.attr('aria-busy', 'true');
      this.$error.prop('hidden', true).text('');

      $.ajax({
        url: this.cartChangeUrl,
        dataType: 'json',
        type: 'post',
        data: {
          id: itemKey,
          quantity: 0
        }
      })
        .done(function(cart) {
          self.render(cart);
        })
        .fail(function() {
          $button.prop('disabled', false);
          self._showError('Unable to remove this item. Please try again.');
        })
        .always(function() {
          self.$drawer.attr('aria-busy', 'false');
        });
    },

    _updateHeaderCount: function(itemCount) {
      if (!theme.cache || !theme.cache.$cartCount) {
        return;
      }

      theme.cache.$cartCount
        .text(itemCount)
        .toggleClass('site-header__cart-count--hidden', itemCount === 0)
        .attr('aria-hidden', itemCount === 0 ? 'true' : 'false');
    },

    _formatMoney: function(cents) {
      var parsedCents = parseInt(cents, 10) || 0;
      var amount = parsedCents / 100;

      if (this.currency === 'JPY') {
        return (
          '¥' +
          String(Math.round(amount)).replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          )
        );
      }

      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function'
      ) {
        return window.Shopify.formatMoney(parsedCents, this.moneyFormat);
      }

      if (window.Intl && this.currency) {
        try {
          return new Intl.NumberFormat(
            document.documentElement.lang || undefined,
            {
              style: 'currency',
              currency: this.currency
            }
          ).format(amount);
        } catch (error) {
          // Fall through to a neutral decimal format.
        }
      }

      return amount.toFixed(2);
    },

    _showError: function(message) {
      this.$error.text(message).prop('hidden', false);
    },

    _handleKeydown: function(evt) {
      var $focusable;
      var firstElement;
      var lastElement;

      if (!this.$drawer.hasClass('cart-drawer--open')) {
        return;
      }

      if (evt.keyCode === 27) {
        evt.preventDefault();
        this.close();
        return;
      }

      if (evt.keyCode !== 9) {
        return;
      }

      $focusable = this.$panel
        .find('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
        .filter(':visible');

      if (!$focusable.length) {
        evt.preventDefault();
        this.$panel.focus();
        return;
      }

      firstElement = $focusable[0];
      lastElement = $focusable[$focusable.length - 1];

      if (evt.shiftKey && document.activeElement === firstElement) {
        evt.preventDefault();
        $(lastElement).focus();
      } else if (!evt.shiftKey && document.activeElement === lastElement) {
        evt.preventDefault();
        $(firstElement).focus();
      }
    },

    _escapeHtml: function(value) {
      var escapeMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };

      return String(value == null ? '' : value).replace(
        /[&<>"']/g,
        function(character) {
          return escapeMap[character];
        }
      );
    }
  };

  return CartDrawer;
})();

theme.initCache = function () {
  theme.cache = {
    $html: $('html'),

    // Header and nav
    $cartCount: $('#CartCount'),
    $siteNav: $('#SiteNav'),

    // Product page
    $addToCartBtn: $('#AddToCart'),
    $productPrice: $('#ProductPrice'),
    $comparePrice: $('#ComparePrice'),
    $comparePriceA11y: $('#ComparePriceA11y'),
    $priceA11y: $('#PriceA11y'),
    $addToCartText: $('#AddToCartText'),
    $productImageWrap: $('#ProductPhoto'),
    $productFeaturedImage: $('#ProductPhotoImg'),
    $productThumbs: $('#ProductThumbs').find('.product-single__thumbnail'),
    $productImageGallery: $('.gallery__item'),
    $tabTrigger: $('.tab-switch__trigger'),
    $tabContent: $('.tab-switch__content'),

    // Collection page
    $sortDropdown: $('#SortBy'),
    $tagsDropdown: $('#BrowseBy'),

    // Cart page
    $emptyCart: $('#EmptyCart'),
    cartNoCookies: 'cart--no-cookies'
  };
};

theme.variables = {
  // Breakpoints from src/stylesheets/sass/_variables.scss.liquid
  mediaQuerySmall     : 'screen and (max-width: 749px)',
  mediaQueryMediumUp  : 'screen and (min-width: 750px)',
  bpSmall             : false,
  queryParams         : {}
};

theme.init = function () {
  theme.initCache();
  theme.cartDrawer = new theme.CartDrawer();
  theme.getQueryParams();
  theme.setBreakpoints();
  theme.stringOverrides();
  theme.styleTextLinks();
  theme.afterCartLoad();
  theme.productCardImageLoadingAnimation();

  

  
};

theme.stringOverrides = function () {
  // Override defaults in theme.strings with potential
  // template overrides

  window.productStrings = window.productStrings || {};
  $.extend(theme.strings, window.productStrings);
};

theme.getQueryParams = function () {
  theme.variables.queryParams = Slate.QueryString.parse(location.search);
};

theme.setBreakpoints = function () {
  enquire.register(theme.variables.mediaQuerySmall, {
    match: function () {
      theme.variables.bpSmall = true;
      theme.cache.$siteNav
        .removeClass('site-nav--open')
        .attr('aria-hidden', 'true')
        .css('display', '');
      $(selectors.mobileMenuTrigger).removeClass('open').attr('aria-expanded', false);
    },
    unmatch: function () {
      theme.variables.bpSmall = false;
      theme.cache.$siteNav
        .removeClass('site-nav--open')
        .attr('aria-hidden', 'true')
        .css('display', '');
      $(selectors.mobileMenuTrigger).removeClass('open').attr('aria-expanded', false);
    }
  });
};

theme.initCollectionSort = function () {
  if (theme.cache.$sortDropdown.length) {
    theme.cache.$sortDropdown.val(theme.cache.$sortDropdown.data('value'));
  }
};

theme.sortCollection = function () {
  theme.variables.queryParams.sort_by = theme.cache.$sortDropdown.val();
  location.search = Slate.QueryString.stringify(theme.variables.queryParams);
};

theme.filterCollection = function () {
  delete theme.variables.queryParams.page;
  delete theme.variables.queryParams.q;
  if ($.isEmptyObject(theme.variables.queryParams)) {
    location.href = theme.cache.$tagsDropdown.val();
  } else {
    location.href = theme.cache.$tagsDropdown.val() + '?' + Slate.QueryString.stringify(theme.variables.queryParams)
  }
};

theme.styleTextLinks = function () {
  $('.rte').find('a:not(:has(img))').addClass('text-link');
};

theme.afterCartLoad = function(cart) {
  if (!theme.cookiesEnabled()) {
    theme.cache.$emptyCart.addClass(theme.cache.cartNoCookies);
  }

  $.getJSON('/cart.js', function(cart) {
    // Update cart count
    var itemCount = parseInt(cart.item_count, 10) || 0;

    theme.cache.$cartCount
      .text(itemCount)
      .toggleClass('site-header__cart-count--hidden', itemCount === 0)
      .attr('aria-hidden', itemCount === 0 ? 'true' : 'false');
  });
};

theme.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;

  if (!cookieEnabled){
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
};

theme.productCardImageLoadingAnimation = function() {
  var selectors = {
    image: '[data-image]',
    imageLink: '[data-image-link]'
  };

  var classes = {
    loadingAnimation: 'product__image-wrapper--loading',
    lazyloaded: '.lazyloaded'
  };

  $(document).on('lazyloaded', function(e) {
    var $target = $(e.target);

    if (!$target.is(selectors.image)) {
      return;
    }

    $target.closest(selectors.imageLink).removeClass(classes.loadingAnimation);
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  $(selectors.image + classes.lazyloaded)
    .closest(selectors.imageLink)
    .removeClass(classes.loadingAnimation);
};

$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('product-template', theme.Product);
  sections.register('collection-template', theme.Collection);
  sections.register('footer-section', theme.FooterSection);
  sections.register('featured-content-section', theme.FeaturedContentSection);
  sections.register('newsletter-section', theme.NewsletterSection);
  sections.register('sidebar-section', theme.SidebarSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('password-content', theme.PasswordContent);
  sections.register('map', theme.Maps);
  sections.register('product-recommendations', theme.ProductRecommendations);
  
 });

$(theme.init);
